var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _path5, _line, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect5, _rect6, _rect7, _rect8, _rect9, _path13, _path14, _path15, _rect10, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect11, _path31, _path32, _path33, _path34, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle2, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle3, _rect34, _rect35, _rect36, _rect37, _path35, _path36, _mask, _path37, _circle4, _circle5, _circle6, _rect38, _path38, _mask2, _path39, _circle7, _circle8, _circle9, _path40, _circle10, _rect39, _path41, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _rect48, _g, _rect49, _rect50, _path211, _rect51, _rect52, _path212, _rect53, _rect54, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _rect55, _path233, _rect56, _g2, _rect57, _circle11, _circle12, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _mask3, _path244, _path245, _path246, _path247, _path248, _ellipse, _ellipse2, _line2, _rect58, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _circle13, _circle14, _g3, _path261, _path262, _path263, _rect59, _ellipse3, _ellipse4, _ellipse5, _path264, _ellipse6, _path265, _circle15, _circle16, _circle17, _circle18, _circle19, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _circle20, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _ellipse7, _ellipse8, _rect60, _g4, _path327, _ellipse9, _g5, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _rect61, _path346, _path347, _mask4, _path348, _path349, _path350, _mask5, _path351, _path352, _path353, _path354, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3713_17473)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -0.999878,
    width: 1200,
    height: 801,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 251H0V800H881V496.447H816V417.303L370 407.285L122 251Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 666H1198V801H0V666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M621.5 418.5H663.5V665.585L621.5 673.399V418.5Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 414H423.5V673.405L381.5 666.08V414Z",
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 157,
    width: 131,
    height: 118,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 157L381 318V433L131 275V157Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1043.5,
    y1: 799,
    x2: 1043.5,
    y2: -0.999878,
    stroke: "white",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 300.5,
    width: 198,
    height: 127,
    fill: "white",
    stroke: "#232440"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 432.932V318.34L423.5 301.735V427.56L381.5 432.932Z",
    fill: "black",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M663.5 434.905V318.34L621.5 301.735V427.58L663.5 434.905Z",
    fill: "white",
    stroke: "#232440"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M664 318L825 402V519.5L664 435.5V318Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M825.717 466.5H1042.87L1198.5 567.586V798H972.607L825.717 513.514V466.5Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M830.998 466H1045",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L995.5 579.5V852L825 519.5V402Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M978 813L825 519.5V666L978 813Z",
    fill: "#1D1D1D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 29.0001,
    width: 113,
    height: 67,
    fill: "black",
    stroke: "white",
    strokeWidth: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 31.0001,
    width: 144,
    height: 151,
    fill: "white",
    stroke: "black",
    strokeWidth: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 114,
    width: 113,
    height: 81,
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 723.455,
    y: 25.4556,
    width: 154.089,
    height: 161.089,
    fill: "#FFFDFD",
    stroke: "black",
    strokeWidth: 8.91089
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 23.0001,
    width: 83,
    height: 99,
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M675.5 51.5001C675.5 60.3697 667.692 68.8706 653.962 75.2418C640.358 81.5551 621.457 85.5001 600.5 85.5001C579.543 85.5001 560.642 81.5551 547.038 75.2418C533.308 68.8706 525.5 60.3697 525.5 51.5001C525.5 42.6305 533.308 34.1296 547.038 27.7585C560.642 21.4452 579.543 17.5001 600.5 17.5001C621.457 17.5001 640.358 21.4452 653.962 27.7585C667.692 34.1296 675.5 42.6305 675.5 51.5001Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.179 422.32V738.5H34.5V326.5H150.646L300.179 422.32Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280 436.219V718.5H55V348.5H141.063L280 436.219Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 454.584,
    width: 224.268,
    height: 6.81779,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55 541.5H279V548.875H55V541.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55 623.5H279V630.5H55V623.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.798 498.364C241.902 497.957 241.958 497.531 241.958 497.091C241.958 494.28 239.679 492 236.867 492C234.055 492 231.775 494.28 231.775 497.091C231.775 497.531 231.831 497.957 231.936 498.364H224.138C217.109 498.364 211.41 504.063 211.41 511.093V540.368H205.682C203.925 540.368 202.5 541.793 202.5 543.55C202.5 545.308 203.925 546.732 205.682 546.732H270.597C272.354 546.732 273.779 545.308 273.779 543.55C273.779 541.793 272.354 540.368 270.597 540.368H263.596V511.093C263.596 504.063 257.898 498.364 250.868 498.364H241.798Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.775 502.819C220.956 502.819 216.502 504.729 215.865 509.82M237.504 494.546C236.231 493.909 233.685 495.182 234.321 497.091",
    stroke: "white",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 525.275C224.139 528.33 229.654 531.64 232.412 532.912L236.867 527.821C236.083 533.7 233.127 535.557 230.674 536.363C229.543 536.734 229.646 537.367 230.836 537.367H253.414C254.05 536.519 255.323 534.185 255.323 531.64C255.323 528.458 252.778 528.458 252.141 525.275C251.505 522.093 235.594 516.366 232.412 517.638C229.23 518.911 224.139 521.457 224.139 525.275Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M232.412 532.912L231.879 534.068L232.743 534.467L233.37 533.751L232.412 532.912ZM253.414 537.367V538.64H254.05L254.432 538.131L253.414 537.367ZM230.674 536.363L230.276 535.154H230.276L230.674 536.363ZM236.867 527.821L238.129 527.989L238.686 523.809L235.909 526.983L236.867 527.821ZM232.946 531.757C231.632 531.151 229.657 530.055 228.033 528.765C227.22 528.12 226.538 527.46 226.068 526.823C225.59 526.175 225.412 525.659 225.412 525.275H222.866C222.866 526.419 223.376 527.462 224.019 528.334C224.67 529.217 225.539 530.036 226.45 530.759C228.273 532.206 230.435 533.402 231.879 534.068L232.946 531.757ZM225.412 525.275C225.412 523.97 226.287 522.708 227.854 521.515C229.387 520.347 231.329 519.443 232.885 518.82L231.939 516.457C230.313 517.107 228.119 518.112 226.311 519.49C224.536 520.842 222.866 522.762 222.866 525.275H225.412ZM232.885 518.82C233.016 518.768 233.382 518.703 234.077 518.742C234.732 518.778 235.55 518.897 236.487 519.093C238.359 519.485 240.603 520.16 242.784 520.978C244.969 521.797 247.043 522.742 248.59 523.656C249.365 524.115 249.97 524.544 250.383 524.921C250.835 525.334 250.896 525.54 250.893 525.525L253.389 525.026C253.227 524.215 252.652 523.546 252.1 523.042C251.508 522.501 250.74 521.971 249.885 521.465C248.17 520.45 245.948 519.446 243.678 518.595C241.405 517.742 239.035 517.025 237.008 516.601C235.997 516.39 235.044 516.245 234.218 516.2C233.431 516.156 232.604 516.191 231.939 516.457L232.885 518.82ZM250.893 525.525C251.288 527.5 252.325 528.531 253.025 529.309C253.375 529.699 253.611 529.988 253.777 530.319C253.931 530.628 254.05 531.028 254.05 531.64H256.596C256.596 530.66 256.397 529.867 256.054 529.181C255.723 528.518 255.282 528.012 254.917 527.606C254.185 526.793 253.631 526.233 253.389 525.026L250.893 525.525ZM254.05 531.64C254.05 533.821 252.93 535.892 252.396 536.604L254.432 538.131C255.171 537.146 256.596 534.55 256.596 531.64H254.05ZM253.414 536.095H230.836V538.64H253.414V536.095ZM231.071 537.572C232.433 537.124 234.011 536.359 235.352 534.835C236.695 533.309 237.711 531.124 238.129 527.989L235.605 527.653C235.24 530.397 234.385 532.08 233.441 533.153C232.494 534.229 231.368 534.795 230.276 535.154L231.071 537.572ZM233.37 533.751L237.825 528.659L235.909 526.983L231.454 532.074L233.37 533.751ZM230.836 536.095C230.632 536.095 230.583 536.065 230.631 536.084C230.641 536.088 231.053 536.258 231.141 536.8C231.229 537.344 230.89 537.637 230.881 537.645C230.841 537.679 230.877 537.636 231.071 537.572L230.276 535.154C229.905 535.276 229.53 535.451 229.228 535.708C228.957 535.94 228.507 536.46 228.628 537.209C228.749 537.955 229.34 538.307 229.668 538.441C230.035 538.591 230.445 538.64 230.836 538.64V536.095Z",
    fill: "#1E1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 525.275C224.139 528.33 230.924 533.434 233.682 534.706C232.712 535.552 231.653 536.041 230.674 536.363C229.543 536.734 229.646 537.367 230.836 537.367H242.595H253.414C254.05 536.519 255.323 534.185 255.323 531.64C255.323 528.458 252.778 528.458 252.141 525.275C251.505 522.093 235.594 516.366 232.412 517.638C229.23 518.911 224.139 521.457 224.139 525.275Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M233.682 534.706C230.924 533.434 224.139 528.33 224.139 525.275C224.139 521.457 229.23 518.911 232.412 517.638C235.594 516.366 251.505 522.093 252.141 525.275C252.778 528.458 255.323 528.458 255.323 531.64C255.323 534.185 254.05 536.519 253.414 537.367H242.595M236.867 527.821C236.083 533.7 233.127 535.557 230.674 536.363C229.543 536.734 229.646 537.367 230.836 537.367H242.595M247.05 530.185C243.656 529.246 238.013 529.366 242.595 537.367",
    stroke: "#1E1E1E",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.685,
    cy: 523.185,
    r: 1.90926,
    fill: "#232323"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 682.5C221.5 684.433 215.232 686 207.5 686C199.768 686 193.5 684.433 193.5 682.5C193.5 680.567 199.768 679 207.5 679C215.232 679 221.5 680.567 221.5 682.5Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 673C206.1 676.2 204.833 682.667 204 685.5C206.5 683 206.5 673.5 207 671C207.5 668.5 211 664.5 212 662C213 659.5 210 656 209 650.5C208.2 646.1 210.666 638.333 212 635C208.5 636.5 200.5 647.5 199.5 654.5C198.5 661.5 202.5 669 204.5 673Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 666.5C203.1 669.7 203.167 680.834 203.5 686C203.5 685 209.5 673.5 212 673C214.5 672.5 217.5 666.5 218 663C218.5 659.5 222 656.5 222.5 655C223 653.5 218.5 657 216.5 658.5C214.5 660 208.5 662.5 205.5 666.5Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 676.5C214.7 678.9 213.333 682.5 213 684C212 681 212 678 213 673.5C214 669 217.5 666 220 662.5C222.5 659 233 654.5 233 655C233 655.5 228.5 661.5 226.5 663.5C224.5 665.5 224.5 669.5 223 671.5C221.5 673.5 221 673.5 217.5 676.5Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 686.5C205.5 681.667 207.6 671.4 216 669C220 670.2 223.667 668.5 225 667.5C226.2 669.9 223.5 674.833 222 677C220.252 676.418 218.905 675.026 217.925 673.5C214.283 674.833 206.7 679.3 205.5 686.5Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216 669C207.6 671.4 205.5 681.667 205.5 686.5C206.7 679.3 214.283 674.833 217.925 673.5M216 669C220 670.2 223.667 668.5 225 667.5C226.2 669.9 223.5 674.833 222 677C220.252 676.418 218.905 675.026 217.925 673.5M216 669C216.257 670.115 216.885 671.883 217.925 673.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 686C201.5 685.832 201.331 685.327 201.163 684.616C199.6 680.561 193.18 671.959 194.5 668C195.7 664.4 193.667 657.167 192.5 654C196 657 196 661.5 196.5 663C197 664.5 202.5 669.5 203 671.5C203.5 673.5 203 676 201.5 679C200.503 680.994 200.831 683.208 201.163 684.616C201.377 685.17 201.5 685.639 201.5 686Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 706,
    width: 57,
    height: 10,
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.525 696.5C186.125 691.7 190.691 684.5 193.025 681.5C195.025 681.5 202.119 684.014 207.525 683C215.525 681.5 218.858 681 221.025 680C222.691 682.5 224.825 686.7 226.025 689.5C227.525 693 230.025 698.5 228.025 701C226.025 703.5 225.025 702.5 222.525 702.5C220.525 702.5 220.691 707.833 221.025 710.5C219.858 711.667 215.525 714 207.525 714C199.525 714 194.525 710.667 193.025 709V702.5C193.025 701 187.025 702.5 186.525 696.5Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.519 690C194.119 688 199.186 688.167 201.519 688.5C203.019 689 205.919 690.5 205.519 692.5C205.019 695 201.519 695 200.019 696C198.519 697 198.519 700.5 195.019 700C191.519 699.5 190.519 692.5 192.519 690Z",
    fill: "#171717"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.519 698.5C216.519 699 209.519 696 210.019 690C210.686 689 212.519 687 214.519 687C217.019 687 220.019 687 220.519 690C221.019 693 220.519 698 218.519 698.5Z",
    fill: "#171717"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M206.955 703.433C205.679 704.071 204.296 703.167 203.764 702.635C201.371 701.623 202.966 708.22 203.764 708.619C204.562 709.018 206.157 707.023 207.753 706.624C209.349 706.226 209.748 707.821 211.742 707.023C213.737 706.226 211.343 701.439 209.748 700.242C208.152 699.045 208.551 702.635 206.955 703.433Z",
    fill: "#171717"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 716,
    width: 6,
    height: 69,
    transform: "rotate(90 242.5 716)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 658,
    width: 11,
    height: 62,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 670.5,
    width: 10,
    height: 49,
    fill: "white",
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 651,
    width: 24,
    height: 69,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 668,
    width: 24,
    height: 3,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 703,
    width: 24,
    height: 3,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 690,
    width: 22,
    height: 2,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 682,
    width: 22,
    height: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 687,
    r: 2,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 675,
    width: 3,
    height: 32,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 684,
    width: 3,
    height: 26,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 102.009,
    y: 674.727,
    width: 10.9534,
    height: 46,
    transform: "rotate(-8.87505 102.009 674.727)",
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 108.812,
    y: 711.672,
    width: 3,
    height: 9,
    transform: "rotate(-98.5688 108.812 711.672)",
    fill: "#FFFAFA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 718,
    width: 42,
    height: 2,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 242.645,
    y: 567.5,
    width: 17,
    height: 57,
    fill: "#FFFAFA",
    stroke: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 260.145,
    y: 556,
    width: 17,
    height: 69,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 574,
    width: 13,
    height: 3,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 606,
    width: 13,
    height: 3,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 266.145,
    y: 582,
    width: 5,
    height: 20,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 582,
    width: 16,
    height: 2,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 599,
    width: 16,
    height: 2,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 603,
    width: 16,
    height: 2,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 230.214,
    y: 574.013,
    width: 12,
    height: 50,
    transform: "rotate(11.203 230.214 574.013)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.339,
    cy: 608.804,
    r: 3,
    transform: "rotate(11.203 229.339 608.804)",
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 227.165,
    y: 599.198,
    width: 8,
    height: 2,
    transform: "rotate(11.203 227.165 599.198)",
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 224.25,
    y: 613.912,
    width: 8,
    height: 2,
    transform: "rotate(11.203 224.25 613.912)",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 92.166,
    y: 602.667,
    width: 20,
    height: 21.3333,
    fill: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 70.833,
    y: 576,
    width: 16,
    height: 48,
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 584H104.314L103.358 590.124H101.444L100.487 584Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.166 556H81.4993L80.8327 562.667H76.8327L76.166 556Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-1_3713_17473",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1906 587.062C98.1906 586.639 98.5333 586.296 98.956 586.296H105.845C106.268 586.296 106.61 586.639 106.61 587.062V587.827C106.61 588.25 106.268 588.593 105.845 588.593V591.396C110.082 592.683 113.199 596.279 113.479 600.588C113.492 600.67 113.499 600.754 113.499 600.84V601.222V623.803C113.499 624.648 112.814 625.333 111.968 625.333H92.8326C91.9872 625.333 91.3018 624.648 91.3018 623.803V601.222V600.84C91.3018 600.754 91.3088 600.67 91.3223 600.588C91.6025 596.279 94.7189 592.683 98.9561 591.396V588.593H98.956C98.5333 588.593 98.1906 588.25 98.1906 587.827V587.062Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.845 588.593L105.845 587.259L104.512 587.259V588.593H105.845ZM105.845 591.396H104.512V592.385L105.458 592.672L105.845 591.396ZM113.479 600.588L112.148 600.675L112.152 600.74L112.163 600.806L113.479 600.588ZM91.3223 600.588L92.6378 600.806L92.6486 600.74L92.6528 600.675L91.3223 600.588ZM98.9561 591.396L99.3435 592.672L100.289 592.385V591.396H98.9561ZM98.9561 588.593H100.289V587.259H98.9561V588.593ZM98.956 584.963C97.7969 584.963 96.8573 585.903 96.8573 587.062H99.5239C99.5239 587.375 99.2697 587.63 98.956 587.63V584.963ZM105.845 584.963H98.956V587.63H105.845V584.963ZM107.944 587.062C107.944 585.903 107.004 584.963 105.845 584.963V587.63C105.531 587.63 105.277 587.375 105.277 587.062H107.944ZM107.944 587.827V587.062H105.277V587.827H107.944ZM105.845 589.926C107.004 589.926 107.944 588.986 107.944 587.827H105.277C105.277 587.514 105.531 587.259 105.845 587.259L105.845 589.926ZM107.178 591.396V588.593H104.512V591.396H107.178ZM114.809 600.502C114.489 595.578 110.941 591.55 106.232 590.12L105.458 592.672C109.224 593.816 111.908 596.98 112.148 600.675L114.809 600.502ZM112.163 600.806C112.165 600.816 112.166 600.827 112.166 600.84H114.833C114.833 600.681 114.82 600.524 114.794 600.371L112.163 600.806ZM112.166 600.84V601.222H114.833V600.84H112.166ZM112.166 601.222V623.803H114.833V601.222H112.166ZM112.166 623.803C112.166 623.912 112.078 624 111.968 624V626.667C113.55 626.667 114.833 625.384 114.833 623.803H112.166ZM111.968 624H92.8326V626.667H111.968V624ZM92.8326 624C92.7235 624 92.6351 623.912 92.6351 623.803H89.9684C89.9684 625.384 91.2508 626.667 92.8326 626.667V624ZM92.6351 623.803V601.222H89.9684V623.803H92.6351ZM92.6351 601.222V600.84H89.9684V601.222H92.6351ZM92.6351 600.84C92.6351 600.827 92.6361 600.816 92.6378 600.806L90.0068 600.371C89.9815 600.524 89.9684 600.681 89.9684 600.84H92.6351ZM98.5686 590.12C93.8604 591.55 90.312 595.578 89.9918 600.502L92.6528 600.675C92.8931 596.98 95.5773 593.816 99.3435 592.672L98.5686 590.12ZM97.6227 588.593V591.396H100.289V588.593H97.6227ZM98.956 589.926H98.9561V587.259H98.956V589.926ZM96.8573 587.827C96.8573 588.986 97.7969 589.926 98.956 589.926V587.259C99.2697 587.259 99.5239 587.514 99.5239 587.827H96.8573ZM96.8573 587.062V587.827H99.5239V587.062H96.8573Z",
    fill: "black",
    mask: "url(#path-76-inside-1_3713_17473)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2771,
    cy: 605.049,
    r: 1.14815,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9568,
    cy: 603.136,
    r: 0.765432,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.105,
    cy: 607.346,
    r: 1.91358,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1289,
    y: 610.79,
    width: 14.5432,
    height: 5.35803,
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6602 614.305C97.1858 613.462 97.8025 612.646 98.4169 611.865C98.477 611.789 98.7608 611.359 98.8023 611.663C98.8846 612.266 98.6915 612.941 98.6535 613.545C98.6357 613.826 98.6461 614.102 98.7013 614.379C98.7162 614.454 98.7842 614.894 98.9086 614.927C99.0128 614.954 99.4002 614.214 99.4375 614.156C99.4979 614.062 100.163 612.992 100.2 613.029C100.322 613.151 100.326 613.651 100.365 613.813C100.614 614.852 101.717 613.739 102.087 613.338C102.157 613.262 102.257 613.036 102.34 613.144C102.595 613.477 102.954 613.547 103.358 613.603C103.784 613.663 104.192 613.593 104.615 613.593C104.728 613.593 104.936 613.778 105.064 613.816C105.638 613.984 106.23 614.084 106.818 614.185C107.093 614.233 107.39 614.151 107.663 614.114",
    stroke: "#202020",
    strokeWidth: 0.765432,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-2_3713_17473",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2931 558.667C75.2931 557.93 75.8901 557.333 76.6265 557.333H81.0403C81.7766 557.333 82.3736 557.93 82.3736 558.667V560C82.3736 560.484 82.1157 560.908 81.7299 561.141V566.217C85.322 568.477 87.9563 574.825 88.1546 582.412C88.1626 582.496 88.1667 582.581 88.1667 582.667V583.333V622.667C88.1667 624.139 86.9728 625.333 85.5 625.333H72.1667C70.6939 625.333 69.5 624.139 69.5 622.667V583.333V582.667C69.5 582.581 69.5041 582.496 69.512 582.412C69.7104 574.825 72.3446 568.477 75.9368 566.217V561.141C75.551 560.908 75.2931 560.484 75.2931 560V558.667Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7299 561.141L81.0393 560.001L80.3965 560.39V561.141H81.7299ZM81.7299 566.217H80.3965V566.954L81.02 567.346L81.7299 566.217ZM88.1546 582.412L86.8218 582.447L86.823 582.492L86.8273 582.538L88.1546 582.412ZM69.512 582.412L70.8394 582.538L70.8437 582.492L70.8449 582.447L69.512 582.412ZM75.9368 566.217L76.6467 567.346L77.2701 566.954V566.217H75.9368ZM75.9368 561.141H77.2701V560.39L76.6274 560.001L75.9368 561.141ZM76.6265 556C75.1537 556 73.9598 557.194 73.9598 558.667H76.6265V558.667V556ZM81.0403 556H76.6265V558.667H81.0403V556ZM83.7069 558.667C83.7069 557.194 82.513 556 81.0403 556V558.667H81.0403H83.7069ZM83.7069 560V558.667H81.0403V560H83.7069ZM82.4205 562.282C83.1887 561.817 83.7069 560.97 83.7069 560H81.0403C81.0403 560.002 81.04 560.002 81.0404 560.001C81.0406 560 81.041 559.999 81.0411 559.999C81.0411 559.999 81.0409 559.999 81.0403 560C81.0401 560 81.0398 560 81.0396 560.001C81.0394 560.001 81.0393 560.001 81.0393 560.001L82.4205 562.282ZM83.0632 566.217V561.141H80.3965V566.217H83.0632ZM89.4875 582.377C89.3848 578.446 88.6512 574.803 87.4521 571.819C86.2637 568.862 84.5646 566.425 82.4398 565.088L81.02 567.346C82.4873 568.269 83.9015 570.135 84.9778 572.814C86.0435 575.466 86.7262 578.79 86.8218 582.447L89.4875 582.377ZM86.8273 582.538C86.8313 582.58 86.8333 582.623 86.8333 582.667H89.5C89.5 582.539 89.4939 582.412 89.482 582.286L86.8273 582.538ZM86.8333 582.667V583.333H89.5V582.667H86.8333ZM86.8333 583.333V622.667H89.5V583.333H86.8333ZM86.8333 622.667C86.8333 623.403 86.2364 624 85.5 624V626.667C87.7091 626.667 89.5 624.876 89.5 622.667H86.8333ZM85.5 624H72.1667V626.667H85.5V624ZM72.1667 624C71.4303 624 70.8333 623.403 70.8333 622.667H68.1667C68.1667 624.876 69.9575 626.667 72.1667 626.667V624ZM70.8333 622.667V583.333H68.1667V622.667H70.8333ZM70.8333 583.333V582.667H68.1667V583.333H70.8333ZM70.8333 582.667C70.8333 582.623 70.8354 582.58 70.8394 582.538L68.1846 582.286C68.1727 582.412 68.1667 582.539 68.1667 582.667H70.8333ZM75.2269 565.088C73.102 566.425 71.403 568.862 70.2145 571.819C69.0155 574.803 68.2819 578.446 68.1791 582.377L70.8449 582.447C70.9405 578.79 71.6232 575.466 72.6889 572.814C73.7652 570.135 75.1793 568.269 76.6467 567.346L75.2269 565.088ZM74.6034 561.141V566.217H77.2701V561.141H74.6034ZM73.9598 560C73.9598 560.97 74.478 561.817 75.2461 562.282L76.6274 560.001C76.6274 560.001 76.6273 560.001 76.6271 560.001C76.6269 560 76.6267 560 76.6264 560C76.6258 559.999 76.6256 559.999 76.6257 559.999C76.6257 559.999 76.6261 560 76.6264 560.001C76.6267 560.002 76.6265 560.002 76.6265 560H73.9598ZM73.9598 558.667V560H76.6265V558.667H73.9598Z",
    fill: "black",
    mask: "url(#path-83-inside-2_3713_17473)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4997,
    cy: 580.667,
    r: 0.666667,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 583.333,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1663,
    cy: 578.667,
    r: 1.33333,
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5003 592.667C81.5003 593.035 81.2018 593.333 80.8337 593.333C80.4655 593.333 80.167 593.035 80.167 592.667C80.167 592.299 80.4655 592 80.8337 592C81.2018 592 81.5003 592.299 81.5003 592.667Z",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5003,
    cy: 594.667,
    r: 1.33333,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 72.167,
    y: 600,
    width: 13.3333,
    height: 5.33333,
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.375 603.25C74.4281 602.435 75.048 601.551 75.8472 601.285C75.9387 601.254 76.3241 601.138 76.3912 601.257C76.5067 601.462 76.3112 601.913 76.2454 602.104C76.1327 602.432 75.994 602.75 75.8796 603.077C75.7726 603.382 76.2064 603.022 76.2986 602.972C76.6884 602.762 77.2458 602.464 77.6968 602.637C77.9934 602.75 78.0143 602.983 78.0417 603.264C78.0894 603.753 78.561 603.582 78.9028 603.435C79.1131 603.345 79.6228 602.838 79.8611 602.968C80.3664 603.243 80.9488 603.157 81.4954 603.083C81.8252 603.039 82.0963 603.072 82.4167 603.125",
    stroke: "#1F1F1F",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 387,
    width: 17,
    height: 69,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 399,
    width: 13,
    height: 57,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 403,
    width: 9,
    height: 35,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 415,
    width: 3,
    height: 35,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 543,
    width: 17,
    height: 101,
    transform: "rotate(-90 61 543)",
    fill: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7822,
    y: 525.5,
    width: 12,
    height: 82.4348,
    transform: "rotate(-90 70.7822 525.5)",
    fill: "white",
    stroke: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 537,
    width: 4,
    height: 46,
    transform: "rotate(-90 68.5 537)",
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 522,
    width: 4,
    height: 43,
    transform: "rotate(-90 83.5 522)",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M179.685 424.582C180.2 415.826 176.826 399.087 159.212 402.177C137.193 406.04 123.287 433.467 123.287 461.666C123.287 485.258 123.287 492.569 141.442 520.382C148.54 531.256 172.732 556.693 171.187 577.939C169.641 599.185 152.645 604.207 154.19 622.362C155.735 640.518 173.504 645.54 163.847 658.673C154.19 671.807 143.126 655.583 151.872 647.085",
    stroke: "black",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M188.069 405.744C190.773 405.229 196.027 402.113 195.409 393.769C192.447 394.8 186.833 398.637 188.069 405.744Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.732 392.393C175.046 389.975 175.962 383.935 169.114 379.129C168.035 382.073 167.449 388.848 173.732 392.393Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 458.064C150.373 460.813 152.184 466.647 160.443 467.984C160.129 464.864 157.701 458.512 150.5 458.064Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.113 451.266C145.366 451.08 139.495 452.764 137.98 460.993C141.106 460.746 147.509 458.455 148.113 451.266Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M142.565 478.096C140.873 480.267 138.983 486.076 144.954 491.936C146.499 489.208 148.184 482.62 142.565 478.096Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.349 505.779C118.125 504.157 112.26 502.453 106.592 508.607C109.368 510.065 116.006 511.54 120.349 505.779Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.092 488.656C130.243 486.617 124.847 483.756 118.047 488.631C120.469 490.622 126.669 493.415 132.092 488.656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.134 517.748C111.503 516.939 105.402 517.235 102.045 524.899C105.145 525.374 111.902 524.609 114.134 517.748Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.065 532.07C112.39 532.718 107.297 536.091 108.328 544.394C111.235 543.218 116.652 539.107 115.065 532.07Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M121.675 544.47C119.213 545.702 115.007 550.131 117.874 557.991C120.443 556.193 124.8 550.972 121.675 544.47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135.61 582.006C136.712 579.483 137.107 573.388 129.872 569.186C129.05 572.212 129.046 579.012 135.61 582.006Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.189 539.489C122.776 541.738 127.785 545.233 135.127 541.221C132.964 538.95 127.15 535.425 121.189 539.489Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.981 522.978C115.607 525.705 116.886 531.678 124.992 533.752C124.959 530.617 123.112 524.072 115.981 522.978Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 550.47C131.562 553.049 135.517 557.704 143.638 555.693C142.125 552.946 137.399 548.057 130.6 550.47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.188 564.376C143.15 566.955 147.105 571.611 155.226 569.599C153.713 566.853 148.987 561.963 142.188 564.376Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.158 581.597C139.112 583.437 136.231 588.823 141.08 595.642C143.08 593.227 145.896 587.037 141.158 581.597Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.897 584.523C129.219 583.889 123.151 584.589 120.308 592.458C123.432 592.727 130.124 591.516 131.897 584.523Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 576.861C122.09 574.496 117.364 570.626 109.736 574.063C111.717 576.493 117.244 580.455 123.5 576.861Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.783 567.261C122.207 564.57 118.973 559.388 110.646 560.193C111.742 563.131 115.705 568.657 122.783 567.261Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M120.559 509.812C119.779 512.451 120.143 518.549 127.843 521.82C128.284 518.716 127.444 511.968 120.559 509.812Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M128.658 495.865C126.967 498.037 125.076 503.845 131.047 509.706C132.593 506.977 134.278 500.389 128.658 495.865Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 471.426C141.96 469.961 135.992 468.663 130.759 475.192C133.629 476.455 140.353 477.471 144.29 471.426Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.022 441.786C149.697 444.454 153.121 449.512 161.413 448.398C160.208 445.503 156.043 440.128 149.022 441.786Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.029 447.464C139.733 446.949 144.987 443.832 144.369 435.489C141.407 436.519 135.793 440.356 137.029 447.464Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.159 424.115C144.028 426.727 147.813 431.521 156.001 429.803C154.588 427.004 150.041 421.948 143.159 424.115Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 430.467C134.325 429.952 139.579 426.836 138.961 418.492C135.999 419.522 130.385 423.359 131.621 430.467Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140.17 409.396C140.595 412.116 143.535 417.47 151.895 417.129C150.964 414.135 147.315 408.396 140.17 409.396Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.172 402.828C180.161 400.948 174.547 398.542 168.172 403.96C170.75 405.745 177.159 408.017 182.172 402.828Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M149.733 393.859C147.673 395.684 144.752 401.049 149.55 407.903C151.568 405.503 154.43 399.335 149.733 393.859Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 398.243C138.935 396.686 133.023 395.151 127.534 401.465C130.351 402.843 137.029 404.126 141.205 398.243Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M156.545 388.891C157.609 386.232 157.884 379.94 150.477 376.044C149.707 379.205 149.842 386.198 156.545 388.891Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M190.001 421.554C189.743 414.472 185.056 397.991 171.459 393.355C154.462 387.561 148.282 392.196 143.646 397.604C139.011 403.012 137.079 415.76 143.646 428.894C150.213 442.028 150.986 457.479 149.441 463.66C147.895 469.84 135.534 484.519 130.512 492.245C125.491 499.971 111.971 513.491 115.833 529.329C119.696 545.167 135.92 554.824 140.942 566.026C146.737 578.954 138.625 583.409 133.216 583.409C127.592 583.409 123.946 577.229 123.559 572.207C123.173 567.185 122.787 567.572 122.787 567.572",
    stroke: "black",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.682 411.065C175.522 408.569 171.219 404.234 163.278 406.869C164.999 409.49 170.09 413.998 176.682 411.065Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.291 397.579C162.023 394.84 159.396 389.325 151.031 389.184C151.788 392.227 155.1 398.166 162.291 397.579Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M146.707 401.829C145.752 399.248 141.808 394.583 133.682 396.575C135.189 399.325 139.903 404.226 146.707 401.829Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M135.09 413.092C133.698 410.718 129 406.813 121.347 410.194C123.31 412.638 128.808 416.64 135.09 413.092Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.083 423.424C125.967 421.664 120.222 419.589 114.173 425.369C116.851 427.001 123.382 428.896 128.083 423.424Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M123.427 437.204C121.038 435.837 115.02 434.787 110.063 441.528C112.983 442.671 119.743 443.407 123.427 437.204Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.072 453.524C118.324 453.361 112.467 455.094 111.021 463.335C114.145 463.062 120.528 460.718 121.072 453.524Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 472.745C119.897 473.197 114.572 476.189 114.994 484.545C117.979 483.585 123.681 479.88 122.612 472.745Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M124.929 492.06C122.214 492.511 116.889 495.504 117.312 503.86C120.297 502.899 125.999 499.194 124.929 492.06Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M131.11 505.193C128.395 505.645 123.07 508.637 123.492 516.993C126.477 516.033 132.18 512.328 131.11 505.193Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M139.475 517.429C137.01 518.655 132.792 523.072 135.638 530.94C138.212 529.149 142.583 523.94 139.475 517.429Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M147.973 530.563C145.508 531.788 141.29 536.206 144.136 544.074C146.71 542.283 151.081 537.074 147.973 530.563Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M158.15 544.024C155.424 544.401 150.019 547.247 150.214 555.612C153.224 554.733 159.025 551.185 158.15 544.024Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M165.103 556.385C162.377 556.762 156.972 559.609 157.167 567.973C160.177 567.094 165.978 563.546 165.103 556.385Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M168.989 577.447C166.386 576.553 160.278 576.651 156.674 584.201C159.757 584.777 166.535 584.231 168.989 577.447Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M159.751 596.954C157.53 595.328 151.669 593.61 145.987 599.752C148.76 601.216 155.395 602.705 159.751 596.954Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M153.57 608.543C151.35 606.916 145.488 605.199 139.807 611.341C142.58 612.805 149.215 614.294 153.57 608.543Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M153.719 626.79C151.826 624.791 146.367 622.05 139.676 627.073C142.142 629.011 148.402 631.666 153.719 626.79Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M149.946 644.659C150.259 641.924 148.847 635.981 140.697 634.089C140.799 637.223 142.793 643.724 149.946 644.659Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M148.95 657.75C146.927 655.883 141.297 653.515 134.959 658.976C137.549 660.743 143.973 662.972 148.95 657.75Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M156.501 661.924C154.223 663.47 150.639 668.416 154.519 675.828C156.828 673.707 160.457 667.956 156.501 661.924Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M166.283 653.509C165.435 656.128 165.641 662.232 173.255 665.702C173.775 662.61 173.11 655.843 166.283 653.509Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M166.939 643.167C167.556 645.85 170.868 650.982 179.183 650.049C178.041 647.128 173.995 641.663 166.939 643.167Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M157.757 629.486C159.073 631.904 163.644 635.956 171.401 632.821C169.516 630.315 164.148 626.14 157.757 629.486Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M154.853 613.356C155.246 616.081 158.123 621.469 166.487 621.226C165.59 618.221 162.009 612.441 154.853 613.356Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M164.926 594.79C163.993 597.38 164 603.488 171.496 607.204C172.117 604.131 171.673 597.345 164.926 594.79Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M170.704 583.219C170.464 585.962 172.032 591.865 180.229 593.541C180.044 590.411 177.88 583.965 170.704 583.219Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M171.532 567.528C172.165 570.207 175.51 575.318 183.818 574.334C182.659 571.421 178.579 565.981 171.532 567.528Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M164.694 549.22C166.054 551.614 170.697 555.583 178.396 552.308C176.466 549.837 171.024 545.759 164.694 549.22Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M155.424 533.769C156.783 536.162 161.426 540.131 169.125 536.857C167.196 534.385 161.754 530.307 155.424 533.769Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M145.066 519.952C146.766 522.116 151.949 525.35 159.075 520.965C156.798 518.809 150.81 515.587 145.066 519.952Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M133.019 500.548C134.378 502.941 139.021 506.91 146.72 503.636C144.79 501.164 139.349 497.087 133.019 500.548Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.293 481.233C126.652 483.627 131.295 487.596 138.995 484.321C137.065 481.85 131.623 477.772 125.293 481.233Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M124.735 458.841C125.061 461.574 127.807 467.03 136.173 466.991C135.351 463.965 131.911 458.099 124.735 458.841Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M125.507 444.162C125.834 446.895 128.579 452.351 136.946 452.311C136.123 449.286 132.683 443.42 125.507 444.162Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M129.602 429.111C129.33 431.85 130.829 437.772 139.005 439.544C138.857 436.412 136.769 429.941 129.602 429.111Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M140.768 411.681C139.61 414.178 139.079 420.263 146.219 424.625C147.108 421.619 147.264 414.82 140.768 411.681Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.271 401.557C153.92 402.989 150.097 407.752 153.607 415.347C156.018 413.342 159.926 407.777 156.271 401.557Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M162.13 641.012C160.746 638.632 156.063 634.711 148.397 638.064C150.352 640.515 155.836 644.537 162.13 641.012Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M190.66 452.872C198.695 442.056 199.673 427.505 199.158 421.582H164.392C163.877 427.505 164.856 442.056 172.891 452.872H190.66Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.31773
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M757.5 730.5C757.5 735.803 753.135 741.001 744.86 745.833C736.62 750.644 724.664 754.993 709.846 758.653C680.217 765.969 639.259 770.5 594 770.5C548.741 770.5 507.783 765.969 478.154 758.653C463.336 754.993 451.38 750.644 443.14 745.833C434.865 741.001 430.5 735.803 430.5 730.5C430.5 725.197 434.865 719.999 443.14 715.167C451.38 710.357 463.336 706.007 478.154 702.348C507.783 695.031 548.741 690.5 594 690.5C639.259 690.5 680.217 695.031 709.846 702.348C724.664 706.007 736.62 710.357 744.86 715.167C753.135 719.999 757.5 725.197 757.5 730.5Z",
    fill: "white",
    stroke: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.218 351.436C504.308 349.215 497.904 346.38 497.904 346.38C497.904 346.38 491.499 349.215 488.589 351.436C485.679 353.658 483 357.757 483 357.757L485.173 370.009L483 382.043L485.173 394.514L483 418.143H512.807L510.712 394.514L512.807 382.043L510.168 370.009L512.807 357.757C512.807 357.757 510.129 353.658 507.218 351.436Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M500.698 339.379C500.698 339.379 503.716 333.361 506.08 330.627C508.445 327.893 512.807 325.376 512.807 325.376L512.807 353.381C512.807 353.381 508.445 350.864 506.08 348.13C503.716 345.396 500.698 339.379 500.698 339.379Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M495.109 339.379C495.109 339.379 492.092 345.396 489.727 348.13C487.363 350.864 483 353.381 483 353.381L483 325.376C483 325.376 487.363 327.893 489.727 330.627C492.092 333.361 495.109 339.379 495.109 339.379Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M497.904 332.377C497.904 332.377 491.499 329.542 488.589 327.321C485.679 325.099 483 321 483 321L512.808 321C512.808 321 510.129 325.099 507.219 327.321C504.309 329.542 497.904 332.377 497.904 332.377Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.218 351.436C553.308 349.215 546.904 346.38 546.904 346.38C546.904 346.38 540.499 349.215 537.589 351.436C534.679 353.658 532 357.757 532 357.757L534.173 370.009L532 382.043L534.173 394.514L532 418.143H561.807L559.712 394.514L561.807 382.043L559.168 370.009L561.807 357.757C561.807 357.757 559.129 353.658 556.218 351.436Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M549.698 339.379C549.698 339.379 552.716 333.361 555.08 330.627C557.445 327.893 561.807 325.376 561.807 325.376L561.807 353.381C561.807 353.381 557.445 350.864 555.08 348.13C552.716 345.396 549.698 339.379 549.698 339.379Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M544.109 339.379C544.109 339.379 541.092 345.396 538.727 348.13C536.363 350.864 532 353.381 532 353.381L532 325.376C532 325.376 536.363 327.893 538.727 330.627C541.092 333.361 544.109 339.379 544.109 339.379Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M546.904 332.377C546.904 332.377 540.499 329.542 537.589 327.321C534.679 325.099 532 321 532 321L561.808 321C561.808 321 559.129 325.099 556.219 327.321C553.309 329.542 546.904 332.377 546.904 332.377Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M653 359.031C651 356.492 645.5 351.993 645.5 351.993C645.5 351.993 638.699 354.985 636.062 356.995C633.426 359.005 631 362.713 631 362.713L633.5 371.23L631 382.96L632.969 395.967L631 419.403L658 424.403L655.609 399.382L658 387.183L655.609 373.798L658 366.538C658 366.538 655.609 362.343 653 359.031Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5 345.893C648.5 345.893 649.764 342.226 651.906 339.752C654.048 337.278 658 335.177 658 335.177V360.908C658 360.908 655.142 357.751 653 355.277C650.858 352.804 648.5 345.893 648.5 345.893Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M641.969 345.135C641.969 345.135 639.142 349.947 637 352.42C634.858 354.894 631 357.803 631 357.803L631 329.459C631 329.459 636.358 335.9 638.5 338.374C640.642 340.847 641.969 345.135 641.969 345.135Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 339.752C646.5 339.752 641.136 336.643 638.5 334.633C635.864 332.623 631.5 322.903 631.5 322.903L658 329.459C658 329.459 654.542 334.031 651.906 336.04C649.27 338.05 646.5 339.752 646.5 339.752Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M645.5 323.403C645.5 323.403 639.136 320.953 636.5 318.903C633.864 316.853 631.379 309 631.379 309L656.5 318.5C656.5 318.5 655.136 319.353 652.5 321.403C649.864 323.453 645.5 323.403 645.5 323.403Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M394 359.128C396 356.589 401.5 352.09 401.5 352.09C401.5 352.09 408.301 355.082 410.938 357.092C413.574 359.102 416 362.81 416 362.81L413.5 371.327L416 383.057L414.031 396.065L416 419.5L389 424.5L391.391 399.479L389 387.28L391.391 373.895L389 366.635C389 366.635 391.391 362.44 394 359.128Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 345.991C398.5 345.991 397.236 342.323 395.094 339.849C392.952 337.376 389 335.275 389 335.275V361.005C389 361.005 391.858 357.848 394 355.375C396.142 352.901 398.5 345.991 398.5 345.991Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M405.031 345.232C405.031 345.232 407.858 350.044 410 352.517C412.142 354.991 416 357.901 416 357.901L416 329.556C416 329.556 410.642 335.997 408.5 338.471C406.358 340.945 405.031 345.232 405.031 345.232Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5 339.849C400.5 339.849 405.864 336.74 408.5 334.73C411.136 332.72 415.5 323 415.5 323L389 330.5C389 330.5 392.458 334.128 395.094 336.138C397.73 338.147 400.5 339.849 400.5 339.849Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 324.403C401.5 324.403 406.364 321.051 409 319C411.636 316.95 415.621 310 415.621 310L389.5 319.903C389.5 319.903 391.5 321.597 394.5 323C397.5 324.403 401.5 324.403 401.5 324.403Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.218 351.436C455.308 349.215 448.904 346.38 448.904 346.38C448.904 346.38 442.499 349.215 439.589 351.436C436.679 353.658 434 357.757 434 357.757L436.173 370.009L434 382.043L436.173 394.514L434 418.143H463.807L461.712 394.514L463.807 382.043L461.168 370.009L463.807 357.757C463.807 357.757 461.129 353.658 458.218 351.436Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M451.698 339.379C451.698 339.379 454.716 333.361 457.08 330.627C459.445 327.893 463.807 325.376 463.807 325.376L463.807 353.381C463.807 353.381 459.445 350.864 457.08 348.13C454.716 345.396 451.698 339.379 451.698 339.379Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M446.109 339.379C446.109 339.379 443.092 345.396 440.727 348.13C438.363 350.864 434 353.381 434 353.381L434 325.376C434 325.376 438.363 327.893 440.727 330.627C443.092 333.361 446.109 339.379 446.109 339.379Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M448.904 332.377C448.904 332.377 442.499 329.542 439.589 327.321C436.679 325.099 434 321 434 321L463.808 321C463.808 321 461.129 325.099 458.219 327.321C455.309 329.542 448.904 332.377 448.904 332.377Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M448.714 317.143C448.714 317.143 442.821 314.366 440.143 312.191C437.465 310.015 435 306 435 306L462.429 306C462.429 306 459.964 310.015 457.286 312.191C454.608 314.366 448.714 317.143 448.714 317.143Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M497.714 317.143C497.714 317.143 491.821 314.366 489.143 312.191C486.465 310.015 484 306 484 306L511.429 306C511.429 306 508.964 310.015 506.286 312.191C503.608 314.366 497.714 317.143 497.714 317.143Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M546.714 317.143C546.714 317.143 540.821 314.366 538.143 312.191C535.465 310.015 533 306 533 306L560.429 306C560.429 306 557.964 310.015 555.286 312.191C552.608 314.366 546.714 317.143 546.714 317.143Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.218 351.436C602.308 349.215 595.904 346.38 595.904 346.38C595.904 346.38 589.499 349.215 586.589 351.436C583.679 353.658 581 357.757 581 357.757L583.173 370.009L581 382.043L583.173 394.514L581 418.143H610.807L608.712 394.514L610.807 382.043L608.168 370.009L610.807 357.757C610.807 357.757 608.129 353.658 605.218 351.436Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M598.698 339.379C598.698 339.379 601.716 333.361 604.08 330.627C606.445 327.893 610.807 325.376 610.807 325.376L610.807 353.381C610.807 353.381 606.445 350.864 604.08 348.13C601.716 345.396 598.698 339.379 598.698 339.379Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M593.109 339.379C593.109 339.379 590.092 345.396 587.727 348.13C585.363 350.864 581 353.381 581 353.381L581 325.376C581 325.376 585.363 327.893 587.727 330.627C590.092 333.361 593.109 339.379 593.109 339.379Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M595.904 332.377C595.904 332.377 589.499 329.542 586.589 327.321C583.679 325.099 581 321 581 321L610.808 321C610.808 321 608.129 325.099 605.219 327.321C602.309 329.542 595.904 332.377 595.904 332.377Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M595.714 317.143C595.714 317.143 589.821 314.366 587.143 312.191C584.465 310.015 582 306 582 306L609.429 306C609.429 306 606.964 310.015 604.286 312.191C601.608 314.366 595.714 317.143 595.714 317.143Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.275 205.79C112.598 203.746 106.708 201.139 106.708 201.139C106.708 201.139 100.817 203.746 98.1403 205.79C95.4638 207.833 93 211.603 93 211.603L94.999 222.872L93 233.94L94.999 245.41L93 267.143H120.415L118.488 245.41L120.415 233.94L117.988 222.872L120.415 211.603C120.415 211.603 117.951 207.833 115.275 205.79Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M109.277 194.7C109.277 194.7 112.053 189.165 114.227 186.65C116.402 184.136 120.415 181.821 120.415 181.821L120.415 207.578C120.415 207.578 116.402 205.264 114.227 202.749C112.053 200.234 109.277 194.7 109.277 194.7Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M104.138 194.7C104.138 194.7 101.362 200.234 99.1877 202.749C97.013 205.264 93.0003 207.579 93.0003 207.579L93.0003 181.821C93.0003 181.821 97.013 184.136 99.1877 186.65C101.362 189.165 104.138 194.7 104.138 194.7Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M106.707 188.26C106.707 188.26 100.817 185.653 98.1402 183.61C95.4637 181.566 92.9999 177.796 92.9999 177.796L120.415 177.796C120.415 177.796 117.951 181.566 115.275 183.61C112.598 185.653 106.707 188.26 106.707 188.26Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2748 205.79C70.5982 203.746 64.7076 201.139 64.7076 201.139C64.7076 201.139 58.8169 203.746 56.1403 205.79C53.4638 207.833 51 211.603 51 211.603L52.999 222.872L51 233.94L52.999 245.41L51 267.143H78.4152L76.4875 245.41L78.4152 233.94L75.9878 222.872L78.4152 211.603C78.4152 211.603 75.9514 207.833 73.2748 205.79Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2773 194.7C67.2773 194.7 70.0526 189.165 72.2273 186.65C74.402 184.136 78.4147 181.821 78.4147 181.821L78.4147 207.578C78.4147 207.578 74.402 205.264 72.2273 202.749C70.0526 200.234 67.2773 194.7 67.2773 194.7Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1377 194.7C62.1377 194.7 59.3625 200.234 57.1877 202.749C55.013 205.264 51.0003 207.579 51.0003 207.579L51.0003 181.821C51.0003 181.821 55.013 184.136 57.1877 186.65C59.3625 189.165 62.1377 194.7 62.1377 194.7Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7075 188.26C64.7075 188.26 58.8168 185.653 56.1402 183.61C53.4637 181.566 50.9999 177.796 50.9999 177.796L78.415 177.796C78.415 177.796 75.9513 181.566 73.2747 183.61C70.5981 185.653 64.7075 188.26 64.7075 188.26Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2748 205.79C28.5982 203.746 22.7076 201.139 22.7076 201.139C22.7076 201.139 16.8169 203.746 14.1403 205.79C11.4638 207.833 9 211.603 9 211.603L10.999 222.872L9 233.94L10.999 245.41L9 267.143H36.4152L34.4875 245.41L36.4152 233.94L33.9878 222.872L36.4152 211.603C36.4152 211.603 33.9514 207.833 31.2748 205.79Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2773 194.7C25.2773 194.7 28.0526 189.165 30.2273 186.65C32.402 184.136 36.4147 181.821 36.4147 181.821L36.4147 207.578C36.4147 207.578 32.402 205.264 30.2273 202.749C28.0526 200.234 25.2773 194.7 25.2773 194.7Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1377 194.7C20.1377 194.7 17.3625 200.234 15.1877 202.749C13.013 205.264 9.00029 207.579 9.00029 207.579L9.00029 181.821C9.00029 181.821 13.013 184.136 15.1877 186.65C17.3625 189.165 20.1377 194.7 20.1377 194.7Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7075 188.26C22.7075 188.26 16.8168 185.653 14.1402 183.61C11.4637 181.566 8.99989 177.796 8.99989 177.796L36.415 177.796C36.415 177.796 33.9513 181.566 31.2747 183.61C28.5981 185.653 22.7075 188.26 22.7075 188.26Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 174C106.5 174 101.128 171.508 98.6875 169.556C96.2467 167.603 94 164 94 164L119 164C119 164 116.753 167.603 114.313 169.556C111.872 171.508 106.5 174 106.5 174Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 174C64.5 174 59.1283 171.508 56.6875 169.556C54.2467 167.603 52 164 52 164L77 164C77 164 74.7533 167.603 72.3125 169.556C69.8717 171.508 64.5 174 64.5 174Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 174C22.5 174 17.1283 171.508 14.6875 169.556C12.2467 167.603 10 164 10 164L35 164C35 164 32.7533 167.603 30.3125 169.556C27.8717 171.508 22.5 174 22.5 174Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.579 383.197C695.986 379.911 690.279 374.495 690.279 374.495C690.279 374.495 684.573 374.095 681.98 374.74C679.387 375.384 677 377.795 677 377.795L678.937 389.623L677 399.283L678.937 411.304L677 431.225L703.559 444.757L701.691 422.898L703.559 412.815L701.207 400.97L703.559 391.327C703.559 391.327 701.172 386.484 698.579 383.197Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M692.77 369.568C692.77 369.568 695.458 365.614 697.565 364.268C699.672 362.922 703.559 362.676 703.559 362.676L703.559 387.455C703.559 387.455 699.672 383.248 697.565 379.755C695.458 376.263 692.77 369.568 692.77 369.568Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M687.789 367.031C687.789 367.031 685.101 370.985 682.994 372.331C680.887 373.677 677 373.923 677 373.923L677 349.144C677 349.144 680.887 353.352 682.994 356.844C685.101 360.337 687.789 367.031 687.789 367.031Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M690.279 362.105C690.279 362.105 684.573 356.689 681.98 353.402C679.387 350.115 677 345.272 677 345.272L703.559 358.804C703.559 358.804 701.172 361.215 698.579 361.86C695.986 362.504 690.279 362.105 690.279 362.105Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M690.111 348.54C690.111 348.54 684.859 343.407 682.473 340.266C680.087 337.125 677.891 332.454 677.891 332.454L702.33 344.906C702.33 344.906 700.134 347.34 697.748 348.049C695.362 348.758 690.111 348.54 690.111 348.54Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M735.579 404.197C732.986 400.911 727.279 395.495 727.279 395.495C727.279 395.495 721.573 395.095 718.98 395.74C716.387 396.384 714 398.795 714 398.795L715.937 410.623L714 420.283L715.937 432.304L714 452.225L740.559 465.757L738.691 443.898L740.559 433.815L738.207 421.97L740.559 412.327C740.559 412.327 738.172 407.484 735.579 404.197Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M729.77 390.568C729.77 390.568 732.458 386.614 734.565 385.268C736.672 383.922 740.559 383.676 740.559 383.676L740.559 408.455C740.559 408.455 736.672 404.248 734.565 400.755C732.458 397.263 729.77 390.568 729.77 390.568Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M724.789 388.031C724.789 388.031 722.101 391.985 719.994 393.331C717.887 394.677 714 394.923 714 394.923L714 370.144C714 370.144 717.887 374.352 719.994 377.844C722.101 381.337 724.789 388.031 724.789 388.031Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M727.279 383.105C727.279 383.105 721.573 377.689 718.98 374.402C716.387 371.115 714 366.272 714 366.272L740.559 379.804C740.559 379.804 738.172 382.215 735.579 382.86C732.986 383.504 727.279 383.105 727.279 383.105Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M727.111 369.54C727.111 369.54 721.859 364.407 719.473 361.266C717.087 358.125 714.891 353.454 714.891 353.454L739.33 365.906C739.33 365.906 737.134 368.34 734.748 369.049C732.362 369.758 727.111 369.54 727.111 369.54Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.579 425.197C772.986 421.911 767.279 416.495 767.279 416.495C767.279 416.495 761.573 416.095 758.98 416.74C756.387 417.384 754 419.795 754 419.795L755.937 431.623L754 441.283L755.937 453.304L754 473.225L780.559 486.757L778.691 464.898L780.559 454.815L778.207 442.97L780.559 433.327C780.559 433.327 778.172 428.484 775.579 425.197Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M769.77 411.568C769.77 411.568 772.458 407.614 774.565 406.268C776.672 404.922 780.559 404.676 780.559 404.676L780.559 429.455C780.559 429.455 776.672 425.248 774.565 421.755C772.458 418.263 769.77 411.568 769.77 411.568Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M764.789 409.031C764.789 409.031 762.101 412.985 759.994 414.331C757.887 415.677 754 415.923 754 415.923L754 391.144C754 391.144 757.887 395.352 759.994 398.844C762.101 402.337 764.789 409.031 764.789 409.031Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M767.279 404.105C767.279 404.105 761.573 398.689 758.98 395.402C756.387 392.115 754 387.272 754 387.272L780.559 400.804C780.559 400.804 778.172 403.215 775.579 403.86C772.986 404.504 767.279 404.105 767.279 404.105Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M767.111 390.54C767.111 390.54 761.859 385.407 759.473 382.266C757.087 379.125 754.891 374.454 754.891 374.454L779.33 386.906C779.33 386.906 777.134 389.34 774.748 390.049C772.362 390.758 767.111 390.54 767.111 390.54Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.579 447.197C811.986 443.911 806.279 438.495 806.279 438.495C806.279 438.495 800.573 438.095 797.98 438.74C795.387 439.384 793 441.795 793 441.795L794.937 453.623L793 463.283L794.937 475.304L793 495.225L819.559 508.757L817.691 486.898L819.559 476.815L817.207 464.97L819.559 455.327C819.559 455.327 817.172 450.484 814.579 447.197Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M808.77 433.568C808.77 433.568 811.458 429.614 813.565 428.268C815.672 426.922 819.559 426.676 819.559 426.676L819.559 451.455C819.559 451.455 815.672 447.248 813.565 443.755C811.458 440.263 808.77 433.568 808.77 433.568Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M803.789 431.031C803.789 431.031 801.101 434.985 798.994 436.331C796.887 437.677 793 437.923 793 437.923L793 413.144C793 413.144 796.887 417.352 798.994 420.844C801.101 424.337 803.789 431.031 803.789 431.031Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M806.279 426.105C806.279 426.105 800.573 420.689 797.98 417.402C795.387 414.115 793 409.272 793 409.272L819.559 422.804C819.559 422.804 817.172 425.215 814.579 425.86C811.986 426.504 806.279 426.105 806.279 426.105Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M806.111 412.54C806.111 412.54 800.859 407.407 798.473 404.266C796.087 401.125 793.891 396.454 793.891 396.454L818.33 408.906C818.33 408.906 816.134 411.34 813.748 412.049C811.362 412.758 806.111 412.54 806.111 412.54Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.311 227.393C159.871 223.842 154.499 217.846 154.499 217.846C154.499 217.846 149.128 216.866 146.687 217.246C144.247 217.627 142 219.795 142 219.795L143.823 231.82L142 241.283L143.823 253.501L142 273.225L166.999 289.459L165.241 267.41L166.999 257.517L164.785 245.433L166.999 236.029C166.999 236.029 164.752 230.943 162.311 227.393Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M156.843 213.173C156.843 213.173 159.373 209.492 161.356 208.36C163.339 207.229 166.998 207.378 166.998 207.378L166.998 232.157C166.998 232.157 163.339 227.554 161.356 223.847C159.373 220.14 156.843 213.173 156.843 213.173Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M152.155 210.129C152.155 210.129 149.625 213.81 147.642 214.941C145.659 216.072 142 215.923 142 215.923L142 191.144C142 191.144 145.659 195.747 147.642 199.454C149.625 203.161 152.155 210.129 152.155 210.129Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M154.499 205.456C154.499 205.456 149.127 199.459 146.687 195.909C144.246 192.358 142 187.272 142 187.272L166.998 203.506C166.998 203.506 164.751 205.674 162.311 206.055C159.87 206.436 154.499 205.456 154.499 205.456Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M154.341 191.873C154.341 191.873 149.398 186.207 147.152 182.823C144.907 179.44 142.839 174.545 142.839 174.545L165.843 189.483C165.843 189.483 163.775 191.693 161.53 192.16C159.284 192.627 154.341 191.873 154.341 191.873Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.311 252.393C199.871 248.842 194.499 242.846 194.499 242.846C194.499 242.846 189.128 241.866 186.687 242.246C184.247 242.627 182 244.795 182 244.795L183.823 256.82L182 266.283L183.823 278.501L182 298.225L206.999 314.459L205.241 292.41L206.999 282.517L204.785 270.433L206.999 261.029C206.999 261.029 204.752 255.943 202.311 252.393Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 238.173C196.843 238.173 199.373 234.492 201.356 233.36C203.339 232.229 206.998 232.378 206.998 232.378L206.998 257.157C206.998 257.157 203.339 252.554 201.356 248.847C199.373 245.14 196.843 238.173 196.843 238.173Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M192.155 235.129C192.155 235.129 189.625 238.81 187.642 239.941C185.659 241.072 182 240.923 182 240.923L182 216.144C182 216.144 185.659 220.747 187.642 224.454C189.625 228.161 192.155 235.129 192.155 235.129Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M194.499 230.456C194.499 230.456 189.127 224.459 186.687 220.909C184.246 217.358 182 212.272 182 212.272L206.998 228.506C206.998 228.506 204.751 230.674 202.311 231.055C199.87 231.436 194.499 230.456 194.499 230.456Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M194.341 216.873C194.341 216.873 189.398 211.207 187.152 207.823C184.907 204.44 182.839 199.545 182.839 199.545L205.843 214.483C205.843 214.483 203.775 216.693 201.53 217.16C199.284 217.627 194.341 216.873 194.341 216.873Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.311 277.393C239.871 273.842 234.499 267.846 234.499 267.846C234.499 267.846 229.128 266.866 226.687 267.246C224.247 267.627 222 269.795 222 269.795L223.823 281.82L222 291.283L223.823 303.501L222 323.225L246.999 339.459L245.241 317.41L246.999 307.517L244.785 295.433L246.999 286.029C246.999 286.029 244.752 280.943 242.311 277.393Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M236.843 263.173C236.843 263.173 239.373 259.492 241.356 258.36C243.339 257.229 246.998 257.378 246.998 257.378L246.998 282.157C246.998 282.157 243.339 277.554 241.356 273.847C239.373 270.14 236.843 263.173 236.843 263.173Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M232.155 260.129C232.155 260.129 229.625 263.81 227.642 264.941C225.659 266.072 222 265.923 222 265.923L222 241.144C222 241.144 225.659 245.747 227.642 249.454C229.625 253.161 232.155 260.129 232.155 260.129Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M234.499 255.456C234.499 255.456 229.127 249.459 226.687 245.909C224.246 242.358 222 237.272 222 237.272L246.998 253.506C246.998 253.506 244.751 255.674 242.311 256.055C239.87 256.436 234.499 255.456 234.499 255.456Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M234.341 241.873C234.341 241.873 229.398 236.207 227.152 232.823C224.907 229.44 222.839 224.545 222.839 224.545L245.843 239.483C245.843 239.483 243.775 241.693 241.53 242.16C239.284 242.627 234.341 241.873 234.341 241.873Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.311 302.393C278.871 298.842 273.499 292.846 273.499 292.846C273.499 292.846 268.128 291.866 265.687 292.246C263.247 292.627 261 294.795 261 294.795L262.823 306.82L261 316.283L262.823 328.501L261 348.225L285.999 364.459L284.241 342.41L285.999 332.517L283.785 320.433L285.999 311.029C285.999 311.029 283.752 305.943 281.311 302.393Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M275.843 288.173C275.843 288.173 278.373 284.492 280.356 283.36C282.339 282.229 285.998 282.378 285.998 282.378L285.998 307.157C285.998 307.157 282.339 302.554 280.356 298.847C278.373 295.14 275.843 288.173 275.843 288.173Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M271.155 285.129C271.155 285.129 268.625 288.81 266.642 289.941C264.659 291.072 261 290.923 261 290.923L261 266.144C261 266.144 264.659 270.747 266.642 274.454C268.625 278.161 271.155 285.129 271.155 285.129Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M273.499 280.456C273.499 280.456 268.127 274.459 265.687 270.909C263.246 267.358 261 262.272 261 262.272L285.998 278.506C285.998 278.506 283.751 280.674 281.311 281.055C278.87 281.436 273.499 280.456 273.499 280.456Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M273.341 266.873C273.341 266.873 268.398 261.207 266.152 257.823C263.907 254.44 261.839 249.545 261.839 249.545L284.843 264.483C284.843 264.483 282.775 266.693 280.53 267.16C278.284 267.627 273.341 266.873 273.341 266.873Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.311 329.393C319.871 325.842 314.499 319.846 314.499 319.846C314.499 319.846 309.128 318.866 306.687 319.246C304.247 319.627 302 321.795 302 321.795L303.823 333.82L302 343.283L303.823 355.501L302 375.225L326.999 391.459L325.241 369.41L326.999 359.517L324.785 347.433L326.999 338.029C326.999 338.029 324.752 332.943 322.311 329.393Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M316.843 315.173C316.843 315.173 319.373 311.492 321.356 310.36C323.339 309.229 326.998 309.378 326.998 309.378L326.998 334.157C326.998 334.157 323.339 329.554 321.356 325.847C319.373 322.14 316.843 315.173 316.843 315.173Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M312.155 312.129C312.155 312.129 309.625 315.81 307.642 316.941C305.659 318.072 302 317.923 302 317.923L302 293.144C302 293.144 305.659 297.747 307.642 301.454C309.625 305.161 312.155 312.129 312.155 312.129Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M314.499 307.456C314.499 307.456 309.127 301.459 306.687 297.909C304.246 294.358 302 289.272 302 289.272L326.998 305.506C326.998 305.506 324.751 307.674 322.311 308.055C319.87 308.436 314.499 307.456 314.499 307.456Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M314.341 293.873C314.341 293.873 309.398 288.207 307.152 284.823C304.907 281.44 302.839 276.545 302.839 276.545L325.843 291.483C325.843 291.483 323.775 293.693 321.53 294.16C319.284 294.627 314.341 293.873 314.341 293.873Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.311 355.393C360.871 351.842 355.499 345.846 355.499 345.846C355.499 345.846 350.128 344.866 347.687 345.246C345.247 345.627 343 347.795 343 347.795L344.823 359.82L343 369.283L344.823 381.501L343 401.225L367.999 417.459L366.241 395.41L367.999 385.517L365.785 373.433L367.999 364.029C367.999 364.029 365.752 358.943 363.311 355.393Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M357.843 341.173C357.843 341.173 360.373 337.492 362.356 336.36C364.339 335.229 367.998 335.378 367.998 335.378L367.998 360.157C367.998 360.157 364.339 355.554 362.356 351.847C360.373 348.14 357.843 341.173 357.843 341.173Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M353.155 338.129C353.155 338.129 350.625 341.81 348.642 342.941C346.659 344.072 343 343.923 343 343.923L343 319.144C343 319.144 346.659 323.747 348.642 327.454C350.625 331.161 353.155 338.129 353.155 338.129Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M355.499 333.456C355.499 333.456 350.127 327.459 347.687 323.909C345.246 320.358 343 315.272 343 315.272L367.998 331.506C367.998 331.506 365.751 333.674 363.311 334.055C360.87 334.436 355.499 333.456 355.499 333.456Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M355.341 319.873C355.341 319.873 350.398 314.207 348.152 310.823C345.907 307.44 343.839 302.545 343.839 302.545L366.843 317.483C366.843 317.483 364.775 319.693 362.53 320.16C360.284 320.627 355.341 319.873 355.341 319.873Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3713_17473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 537,
    width: 200,
    height: 138
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 423.819,
    y: 537.442,
    width: 198.24,
    height: 136.565,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3713_17473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.152,
    y: 623.64,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.095,
    y: 537.066,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.064,
    y: 640.955,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.72,
    y: 554.381,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.689,
    y: 658.27,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.87,
    y: 571.696,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.122,
    y: 589.01,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.319,
    y: 606.325,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.902,
    y: 623.64,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.845,
    y: 537.066,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.814,
    y: 640.955,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.47,
    y: 554.381,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.439,
    y: 658.27,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.62,
    y: 571.696,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.873,
    y: 589.01,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.069,
    y: 606.325,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.652,
    y: 623.64,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.595,
    y: 537.066,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.564,
    y: 640.955,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.22,
    y: 554.381,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.189,
    y: 658.27,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.37,
    y: 571.696,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.623,
    y: 589.01,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.819,
    y: 606.325,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.402,
    y: 623.64,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.345,
    y: 537.066,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.314,
    y: 640.955,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.97,
    y: 554.381,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.939,
    y: 658.27,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.12,
    y: 571.696,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.373,
    y: 589.01,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.569,
    y: 606.325,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.153,
    y: 623.64,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.095,
    y: 537.066,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.064,
    y: 640.955,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.72,
    y: 554.381,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.689,
    y: 658.27,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.87,
    y: 571.696,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.123,
    y: 589.01,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.319,
    y: 606.325,
    width: 45.75,
    height: 16.3148,
    fill: "white",
    stroke: "black"
  }))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 103.085,
    fill: "#181818"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 520,
    width: 215,
    height: 18,
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M459.062 572.684C459.062 572.684 519.599 577.258 548.93 609.37C575.489 638.448 581.529 674.007 581.529 674.007H459.062V572.684Z",
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 1.76213,
    fill: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 623,
    y: 538,
    width: 136,
    height: 1.99999,
    transform: "rotate(90 623 538)",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M452.895 570.922L461.705 572.67V674.007H452.895V570.922Z",
    fill: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 665.196,
    width: 141.851,
    height: 8.81065,
    fill: "#333438"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 672,
    width: 200,
    height: 2,
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M849.853 473.768C847.443 469.646 842.227 461.982 842.227 461.982C842.227 461.982 837.09 458.66 834.76 457.73C832.43 456.659 830.307 457.27 830.307 457.27C830.932 461.852 831.547 466.594 832.182 471.497C831.646 474.919 831.121 478.39 830.595 481.892C831.22 487.035 831.825 491.987 832.459 496.76C831.934 503.433 831.388 509.886 830.823 516.199C838.479 528.615 846.402 542.612 854.861 558C854.613 546.955 854.098 535.989 853.453 525.124C853.979 520.641 854.484 516.119 855 511.537C854.177 505.694 853.354 500.021 852.551 494.498C853.195 490.566 853.146 489.542 853.8 486C853.8 486 852.253 477.81 849.853 473.768Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M844.379 458.5C844.379 458.5 846.69 456.129 848.534 455.899C850.379 455.679 853.8 457.28 853.8 457.28C854.008 464.463 854.226 471.837 854.435 479.391C854.435 479.391 850.835 474.178 848.871 470.086C846.908 465.924 844.379 458.5 844.379 458.5Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M839.877 453.728C839.877 453.728 837.537 455.999 835.653 456.049C833.768 456.029 830.288 453.568 830.288 453.568C830.208 446.134 830.129 438.861 830.06 431.747C830.06 431.747 833.53 437.67 835.454 441.952C837.388 446.224 839.877 453.728 839.877 453.728Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M842.029 450.506C842.029 450.506 836.843 442.682 834.502 438.35C832.162 433.998 830 428.455 830 428.455C837.864 437.18 845.787 445.644 853.701 453.938C853.701 453.938 851.658 454.889 849.377 454.248C847.096 453.598 842.029 450.506 842.029 450.506Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M841.593 438.38C841.593 438.38 836.852 431.187 834.691 427.185C832.529 423.193 830.545 418 830.545 418C837.685 425.734 844.954 433.478 852.223 441.302C852.223 441.302 850.369 442.322 848.296 441.752C846.214 441.172 841.593 438.38 841.593 438.38Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M870.099 468.505C872.539 473.727 877.886 483.79 877.886 483.79C877.886 483.79 883.182 488.482 885.572 489.742C887.952 491.035 892.5 488.001 892.5 488.001C882.5 477.759 873.765 466.715 865.319 457C865.319 457 867.597 463.432 870.099 468.505Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M877.856 500.849C877.856 500.849 872.175 489.145 869.552 483.16C866.939 477.408 864.499 470.263 864.499 470.263C873.522 481.983 882.5 492 892.5 504.595C892.5 504.595 888.63 510.779 886.089 508.873C883.496 506.983 877.856 500.849 877.856 500.849Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M870.443 506.419C872.559 506.834 875.304 504.595 875.304 504.595C875.304 504.595 872.671 493.936 870.575 488.001C868.448 482.265 864.529 474.556 864.529 474.556C864.519 483.757 864.529 491.416 864.499 500.849L870.443 506.419Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M880.215 512.785C880.215 512.785 882.929 510.464 885.046 510.928C887.132 511.426 890.889 515.388 890.889 515.388C890.706 526.429 890.585 537.105 890.554 547.085C890.554 547.085 886.767 537.934 884.762 531.187C882.737 524.34 880.215 512.785 880.215 512.785Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M885.704 536.724C883.192 529.628 877.653 516.498 877.653 516.498C877.653 516.498 871.992 510.099 869.4 508.259C866.797 506.469 864.134 504.595 864.134 504.595C864.711 509.569 865.613 516.896 866.19 521.986C865.491 524.655 864.823 527.241 864.134 529.811C864.681 535.348 865.187 541.167 865.684 547.234C864.833 554.379 863.942 561.673 863 569.051C873 591 883.5 606 889.309 619C888.975 609.07 888.6 599.256 888.165 589.524C888.914 585.579 889.623 581.667 890.352 577.787C889.592 572.416 888.843 566.929 888.114 561.392C888.944 558.043 889.765 554.777 890.565 551.611C890.565 551.611 888.195 543.554 885.704 536.724Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M926.913 584.883C923.889 579.045 917.288 568.669 917.288 568.669C917.288 568.669 910.775 565.295 907.821 564.914C904.866 564.534 902.148 566.712 902.148 566.712C902.899 572.396 903.65 578.026 904.401 583.603C903.663 587.361 902.926 591.066 902.188 594.719C902.926 600.296 903.657 608.338 904.401 614C903.631 621.834 902.853 627.164 902.049 634.835C912.142 650.474 922.285 678.529 932.733 695C932.068 682.908 929.198 656.543 928.5 644.5C929.231 639.572 932.275 636.905 933 631.905C932.078 625.193 931.149 618.569 930.213 612.032C931.096 607.492 931.966 603.025 932.822 598.632C932.822 598.632 929.966 590.71 926.913 584.883Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M920.035 563.021C920.035 563.021 922.999 558.896 925.341 558.124C927.674 557.384 932.012 559.119 932.012 559.119C932.262 570.414 932.503 581.763 932.733 593.164C932.733 593.164 928.178 585.475 925.697 579.605C923.217 573.693 920.035 563.021 920.035 563.021Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M914.353 556.972C914.353 556.972 911.358 561.192 908.957 562.048C906.575 562.894 902.138 561.329 902.138 561.329C902.105 549.653 902.066 537.959 902.02 526.247C902.02 526.247 906.427 534.211 908.819 540.208C911.24 546.226 914.353 556.972 914.353 556.972Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M917.1 551.334C917.1 551.334 910.597 540.811 907.643 534.835C904.708 528.849 902 520.758 902 520.758C911.955 531.764 921.919 542.789 931.893 553.83C931.893 553.83 929.304 555.819 926.419 555.332C923.523 554.856 917.1 551.334 917.1 551.334Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M916.685 532.265C916.685 532.265 910.765 522.239 908.077 516.527C905.39 510.795 902.919 503 902.919 503C911.984 513.252 921.053 523.599 930.124 534.042C930.124 534.042 927.772 536.147 925.144 535.776C922.515 535.427 916.685 532.265 916.685 532.265Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M972.968 643.205C969.635 637.392 962.279 627.198 962.279 627.198C962.279 627.198 954.88 623.916 951.536 623.336C948.182 622.526 945.108 624.096 945.108 624.096C945.935 630.293 946.769 636.669 947.61 643.225C946.769 647.8 945.935 652.406 945.108 657.041C945.928 664.131 946.751 671.294 947.578 678.531C946.693 688.855 943.949 697.242 943 707.5C954.275 726.829 966.827 753 979.299 774.5C978.479 758.46 978.084 735.043 977.206 719.249C977.969 712.526 978.724 705.763 979.471 698.96C978.407 690.556 977.35 682.356 976.3 674.359C977.286 668.41 978.285 662.674 979.299 657.151C979.299 657.151 976.279 648.958 972.968 643.205Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M965.698 620.895C965.698 620.895 969.236 616.013 972.018 614.652C974.801 613.262 979.957 613.902 979.957 613.902C979.813 626.067 979.669 638.409 979.525 650.928C979.525 650.928 974.553 643.555 971.867 637.632C969.16 631.7 965.698 620.895 965.698 620.895Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M959.237 615.363C959.237 615.363 955.753 619.765 953.025 620.545C950.307 621.165 945.28 618.804 945.28 618.804C945.28 607.919 945.27 597.161 945.248 586.53C945.248 586.53 950.274 593.703 953.014 599.255C955.753 604.908 959.237 615.363 959.237 615.363Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M962.484 609.31C962.484 609.31 955.052 599.676 951.676 594.213C948.311 588.801 945.28 576.565 945.28 576.565C956.5 589.961 968.287 599.415 980 608.219C980 608.219 976.797 611.141 973.356 611.421C969.948 611.641 962.484 609.31 962.484 609.31Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M962.139 589.961C962.139 589.961 955.236 581.467 952.097 576.565C948.991 571.753 947.75 559 947.75 559C957 567.5 967.5 578.5 978.307 587.29C978.307 587.29 975.373 590.421 972.18 590.942C969.02 591.462 962.139 589.961 962.139 589.961Z",
    fill: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 579,
    width: 7,
    height: 221,
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L831 402L1002 579L995 579L825 402Z",
    fill: "#FFFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3713_17473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 550,
    y: 110,
    width: 109,
    height: 83
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 110,
    width: 108.091,
    height: 82,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3713_17473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.642,
    y: 147.236,
    width: 11.8287,
    height: 10.6818,
    fill: "#FFFEFE",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.361 176.804C647.705 175.657 647.504 168.967 647.361 165.766L639.906 168.92L641.483 178.955V184.832C641.483 188.158 642.534 193.099 643.06 195.154L648.077 194.724C649.368 188.416 647.791 182.682 647.361 181.965C646.93 181.248 646.93 178.238 647.361 176.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.794 163.902L614.675 169.35C614.436 171.835 613.93 176.89 613.815 177.234C613.672 177.664 613.385 183.255 613.242 183.972C613.127 184.546 610.231 190.805 608.798 193.864C607.268 194.676 604.153 195.727 603.923 193.434C603.637 190.567 606.361 180.962 606.504 180.675C606.647 180.388 606.934 178.955 607.794 177.234C608.482 175.858 608.081 167.773 607.794 163.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.361 176.804C647.705 175.657 647.504 168.967 647.361 165.766L639.906 168.92L641.483 178.955V184.832C641.483 188.158 642.534 193.099 643.06 195.154L648.077 194.724C649.368 188.416 647.791 182.682 647.361 181.965C646.93 181.248 646.93 178.238 647.361 176.804Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.794 163.902L614.675 169.35C614.436 171.835 613.93 176.89 613.815 177.234C613.672 177.664 613.385 183.255 613.242 183.972C613.127 184.546 610.231 190.805 608.798 193.864C607.268 194.676 604.153 195.727 603.923 193.434C603.637 190.567 606.361 180.962 606.504 180.675C606.647 180.388 606.934 178.955 607.794 177.234C608.482 175.858 608.081 167.773 607.794 163.902Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.784,
    y: 145.839,
    width: 12.3287,
    height: 9.74825,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.574 178.955C591.23 178.152 590.379 170.497 589.997 166.769C589.997 165.278 594.68 164.237 597.021 163.902C596.907 165.049 597.547 174.033 597.882 178.381C598.885 179.815 599.602 184.832 600.032 186.266C600.376 187.413 600.462 191.713 600.462 193.72H594.298C594.154 193.147 592.864 188.99 592.721 187.556C592.577 186.122 592.004 179.958 591.574 178.955Z",
    fill: "#FFFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.892 164.332C560.58 164.676 562.664 166.1 563.619 166.769C562.807 171.596 561.182 181.392 561.182 181.965V185.836V193.72H555.161C554.731 193.004 554.588 187.556 554.588 185.836C554.588 184.116 555.161 178.955 555.591 177.521C556.021 176.088 555.591 166.339 555.591 166.053C555.591 165.766 559.032 163.902 559.892 164.332Z",
    fill: "#FFFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.574 178.955C591.23 178.152 590.379 170.497 589.997 166.769C589.997 165.278 594.68 164.237 597.021 163.902C596.907 165.049 597.547 174.033 597.882 178.381C598.885 179.815 599.602 184.832 600.032 186.266C600.376 187.413 600.462 191.713 600.462 193.72H594.298C594.154 193.147 592.864 188.99 592.721 187.556C592.577 186.122 592.004 179.958 591.574 178.955Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.892 164.332C560.58 164.676 562.664 166.1 563.619 166.769C562.807 171.596 561.182 181.392 561.182 181.965V185.836V193.72H555.161C554.731 193.004 554.588 187.556 554.588 185.836C554.588 184.116 555.161 178.955 555.591 177.521C556.021 176.088 555.591 166.339 555.591 166.053C555.591 165.766 559.032 163.902 559.892 164.332Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.773 153.595C577.015 153.117 579.787 151.932 580.934 151.015C582.081 150.097 586.955 151.493 589.248 152.305C590.539 152.878 593.291 154.025 593.979 154.025C594.839 154.025 599.57 157.036 599.283 159.186C598.997 161.336 598.28 162.77 597.706 162.77C597.133 162.77 594.839 161.91 593.119 163.487C591.399 165.064 589.535 164.777 589.822 166.354C590.108 167.931 591.542 170.655 590.395 171.515C589.478 172.203 590.682 174.286 591.399 175.242C591.255 176.006 590.854 177.593 590.395 177.822C589.822 178.109 590.395 180.259 590.395 180.403C590.395 180.517 591.733 181.597 592.402 182.123C593.406 186.185 595.384 194.538 595.269 195.455L561.007 195.885C560.915 191.643 561.081 183.014 562.432 181.281C562.769 180.606 563.444 178.969 563.444 177.822C563.444 176.389 562.28 173.092 562.432 171.515C562.584 169.938 564.448 167.214 564.448 166.784C564.448 166.44 563.205 165.972 562.584 165.78C561.103 164.968 557.71 163.687 555.99 165.064C555.607 165.207 554.843 165.178 554.843 163.917C554.843 162.34 554.269 160.906 554.843 159.616C555.416 158.326 557.423 156.749 557.997 156.319C558.57 155.889 559.717 154.168 561.581 154.599C563.444 155.029 567.458 154.455 567.601 154.025C567.716 153.681 569.274 152.257 570.039 151.588C571.472 152.454 574.626 154.067 575.773 153.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.236 165.059C590.465 163.797 591.287 163.864 591.67 164.056C591.67 163.817 591.842 163.339 592.53 163.339C593.39 163.339 593.247 163.052 594.393 162.335C595.54 161.618 595.11 161.618 596.83 161.618C598.551 161.618 597.404 161.762 598.551 161.618C599.698 161.475 600.558 162.909 600.701 164.056C600.844 165.202 598.981 164.486 598.551 165.059C598.121 165.632 597.691 165.059 596.83 165.059C595.97 165.059 595.827 166.206 595.11 166.636C594.393 167.066 593.82 166.636 592.817 166.636C591.813 166.636 591.096 168.07 590.236 168.213C589.376 168.356 589.949 166.636 590.236 165.059Z",
    fill: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.988 163.339C560.363 163.339 560.636 163.667 560.807 164C561.246 164.264 561.808 164.486 562.425 164.486C563.858 164.486 563.858 165.632 564.145 166.063C564.432 166.493 563.142 168.213 562.855 167.066C562.568 165.919 561.851 166.063 561.421 165.632C560.991 165.202 559.988 166.063 558.984 166.063C557.981 166.063 556.834 166.636 555.687 167.639C554.54 168.643 554.254 167.066 553.393 166.063C552.533 165.059 554.11 164.486 556.261 164.486C557.264 164.486 556.834 164.056 558.984 164.486C559.701 164.916 559.271 163.339 559.988 163.339Z",
    fill: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.991 164.486C560.896 164.103 560.561 163.339 559.988 163.339M559.988 163.339C559.271 163.339 559.701 164.916 558.984 164.486C556.834 164.056 557.264 164.486 556.261 164.486C554.11 164.486 552.533 165.059 553.393 166.063C554.254 167.066 554.54 168.643 555.687 167.639C556.834 166.636 557.981 166.063 558.984 166.063C559.988 166.063 560.991 165.202 561.421 165.632C561.851 166.063 562.568 165.919 562.855 167.066C563.142 168.213 564.432 166.493 564.145 166.063C563.858 165.632 563.858 164.486 562.425 164.486C561.278 164.486 560.322 163.721 559.988 163.339ZM591.67 164.056C591.287 163.864 590.465 163.797 590.236 165.059C589.949 166.636 589.376 168.356 590.236 168.213C591.096 168.07 591.813 166.636 592.817 166.636C593.82 166.636 594.393 167.066 595.11 166.636C595.827 166.206 595.97 165.059 596.83 165.059C597.691 165.059 598.121 165.632 598.551 165.059C598.981 164.486 600.844 165.202 600.701 164.056C600.558 162.909 599.698 161.475 598.551 161.618C597.404 161.762 598.551 161.618 596.83 161.618C595.11 161.618 595.54 161.618 594.393 162.335C593.247 163.052 593.39 163.339 592.53 163.339C591.842 163.339 591.67 163.817 591.67 164.056Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.713 177.531C590.809 178.439 591.037 179.911 590.713 179.928C589.327 180.001 584.463 179.907 578.624 179.898C579.245 184.365 580.621 195.355 580.392 196.158L573.081 195.871C572.937 191.4 573.119 180.794 573.463 180.398C573.893 179.904 571.456 180.892 571.026 179.928C567.079 179.98 564.006 180.107 563.715 180.398C562.425 180.398 562.167 179.366 562.855 177.531C564.657 177.414 567.588 177.07 570.664 176.83C570.861 176.457 571.201 176.145 571.743 175.954C574.18 175.094 574.467 176.607 574.753 176.599C575.87 176.568 577.036 176.572 578.216 176.602C579.186 175.963 580.252 175.373 580.631 175.524C580.888 175.627 581.22 176.127 581.492 176.742C585.009 176.947 588.381 177.298 590.713 177.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.224 131.867C566.256 125.559 571.293 123.027 573.682 122.549C573.348 122.166 573.74 121.631 577.983 122.549C583.287 123.696 582.857 126.563 585.151 129.43C587.444 132.297 587.444 137.171 587.588 137.745C587.731 138.318 588.305 141.615 589.738 142.475C591.172 143.335 592.319 146.653 592.749 149.643C593.179 152.633 587.588 155.664 586.298 155.664C585.007 155.664 584.434 154.661 582.284 153.8C580.133 152.94 579.99 150.647 580.498 148.926C580.905 147.55 580.667 146.838 580.498 146.653H571.675C571.675 146.653 570.815 150.933 570.242 152.94C569.668 154.947 565.798 155.521 563.074 155.664C560.35 155.807 560.063 150.79 559.777 148.926C559.49 147.063 561.497 145.056 563.074 144.769C564.651 144.482 563.934 139.751 565.224 131.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.964 130.653C576.014 130.309 574.666 129.076 574.236 128.503C571.369 127.642 570.222 130.653 569.219 131.656C568.215 132.66 568.215 137.534 568.072 139.398C567.929 141.261 569.649 146.279 569.792 146.996C569.936 147.712 573.806 151.296 574.236 151.296C574.666 151.296 576.96 151.44 577.533 151.296C578.107 151.153 582.121 147.139 582.551 146.279C582.981 145.419 583.698 139.971 583.698 139.398C583.698 138.824 582.981 133.807 582.981 133.233C582.981 132.66 580.401 131.083 577.964 130.653Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.095 137.018C577.908 136.635 579.762 135.985 580.679 136.444C581.157 136.54 582.113 136.788 582.113 137.018M574.228 136.587C573.32 136.349 571.332 135.928 570.644 136.157C569.956 136.387 569.784 136.54 569.784 136.587",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.099 138.241C578.673 137.907 580.049 137.496 580.966 138.528M570.645 137.955C571.218 137.62 572.594 137.209 573.512 138.241",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.077,
    cy: 138.098,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.532,
    cy: 138.385,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.945 142.399C575.089 142.59 575.433 142.972 575.662 142.972C575.891 142.972 576.236 142.59 576.379 142.399",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.081 145.553C574.228 145.983 576.092 146.499 577.812 146.269",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.654 146.269C574.801 146.699 575.088 146.699 576.521 146.843",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.819,
    cy: 132.061,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 583.819 132.061)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.271 132.441C622.074 130.721 625.046 130.004 626.432 129.861C629.013 129.247 634.46 132.441 635.033 133.445C635.607 134.448 635.177 139.179 635.32 140.326C635.464 141.473 634.46 144.627 634.46 146.06C634.46 147.494 630.733 150.361 630.159 150.934C629.586 151.508 626.862 151.364 625.715 150.934C624.568 150.504 621.271 146.347 620.985 145.343C620.698 144.34 620.124 139.323 620.268 138.319C620.411 137.316 620.268 134.592 621.271 132.441Z",
    fill: "#FFFEFE",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.982 143.976C627.221 144.214 627.842 144.549 628.416 143.976M629.563 139.675C629.993 139.245 631.225 138.643 632.716 139.675M625.262 139.675C624.832 139.197 623.685 138.528 622.538 139.675",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.118 146.953C626.265 146.761 628.817 146.494 629.849 146.953",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.14,
    cy: 139.532,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.972,
    cy: 139.532,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.7 156.734C607.865 158.111 607.502 160.462 607.55 161.465V162.039C607.789 162.325 608.439 162.956 609.127 163.185C609.987 163.472 611.421 164.476 611.564 165.336C611.707 166.196 612.711 167.056 613.714 167.343C614.718 167.629 615.148 168.776 614.718 170.497C614.288 172.217 613.427 177.234 613.284 177.664C613.169 178.009 614.479 179.815 615.148 180.675V182.539C615.148 182.73 614.861 183.227 613.714 183.685C612.281 184.259 608.983 194.437 609.127 194.867C609.27 195.297 643.102 195.011 643.102 194.437C643.102 193.864 641.669 185.979 641.669 185.262C641.669 184.546 640.809 183.685 640.379 183.112C639.948 182.539 640.809 180.245 641.669 179.671C642.529 179.098 641.955 177.091 642.386 175.514C642.816 173.937 640.522 170.21 640.379 168.776C640.235 167.343 641.382 167.486 641.955 166.626C642.529 165.766 644.106 165.622 644.393 165.336C644.679 165.049 645.539 166.196 646.543 166.196C647.546 166.196 647.403 164.332 647.403 163.902C647.403 163.472 647.546 161.465 646.973 159.745C646.514 158.369 644.201 157.164 643.102 156.734C642.003 155.444 639.49 152.72 638.228 152.147C636.651 151.43 633.784 151.574 633.497 152.147C633.211 152.72 630.057 154.011 627.62 154.154C625.67 154.269 623.176 152.099 622.172 151C621.647 151.048 620.595 151.229 620.595 151.574C620.595 152.004 617.011 154.871 616.725 154.871C616.438 154.871 615.578 155.301 613.714 154.871C611.851 154.441 611.994 155.014 609.7 156.734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.546 137.5C624.546 137.5 624.197 136.907 623.546 137C622.895 137.093 621.74 137.55 621.546 137.938M629.046 137.5C629.472 137.384 631.325 136.568 632.046 137C632.511 137.279 632.813 137.821 633.046 137.938",
    stroke: "black",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.336 129.973C625.107 129.628 625.145 128.587 625.336 128.109C625.336 126.916 627.343 125.769 631.214 126.916C635.084 128.063 637.447 133.7 637.877 134.13C638.221 134.474 638.881 142.062 639.598 144.738C640.075 146.841 641.478 149.24 643.542 150.616C646.123 152.336 645.263 154.63 644.403 156.637C643.542 158.644 639.098 157.64 638.525 157.784C637.952 157.927 637.808 158.787 635.371 158.787C633.422 158.787 633.316 157.354 633.508 156.637C633.03 156.207 631.902 155.06 631.214 153.913C630.526 152.766 630.927 151.237 631.214 150.616C631.787 149.135 633.049 145.885 633.508 144.738C634.081 143.305 634.798 135.993 634.511 134.13C634.224 132.266 633.077 132.553 631.214 131.836C629.35 131.119 625.623 130.403 625.336 129.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.476 130.259L624.763 128.539C624.906 127.679 624.688 126.629 623.398 127.203C622.108 127.776 620.244 128.826 618.954 130.259C617.664 131.693 616.804 137.525 616.804 139.101C616.804 140.678 615.084 143.115 615.084 144.262C615.084 145.409 615.084 147.703 615.657 148.563C616.23 149.423 617.165 150.857 616.878 151.573C616.591 152.29 615.301 153.913 615.301 153.053C615.301 152.193 616.305 153.483 615.301 152.049C615.301 151.046 613.868 152.336 613.438 153.053C613.008 153.77 614.584 155.347 614.584 155.777C614.584 156.207 616.018 157.497 617.308 157.497C618.598 157.497 619.315 156.637 619.459 156.637C619.602 156.637 621.035 154.917 622.039 153.913C623.042 152.91 622.899 150.042 622.756 148.896C622.612 147.749 620.175 141.011 620.175 139.291C620.175 137.57 620.605 134.13 621.466 132.553C622.154 131.291 623.759 130.498 624.476 130.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.28 164.832C644.706 165.405 644.288 165.262 643.857 164.832C642.854 165.357 640.646 166.552 639.843 167.126C638.84 167.842 639.987 168.416 640.56 169.419C641.134 170.423 641.564 168.846 642.137 168.416C642.711 167.986 642.567 167.842 643.857 167.842C645.148 167.842 645.291 167.842 646.008 167.126C646.725 166.409 646.868 166.695 647.298 166.695C647.728 166.695 648.158 167.556 648.875 167.842C649.592 168.129 649.735 167.556 649.735 166.695C649.735 165.835 650.308 166.265 651.025 165.979C651.742 165.692 650.022 164.832 649.735 164.258C649.448 163.685 648.732 163.255 647.728 163.112C646.725 162.968 646.008 163.398 646.008 164.258C646.008 165.119 645.853 164.258 645.28 164.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.462 164.258C611.774 163.8 611.411 164.45 611.315 164.832C611.077 164.497 610.599 163.771 610.599 163.542C610.599 163.255 609.308 162.538 609.308 162.108C609.308 161.678 608.735 162.682 607.732 162.538C606.728 162.395 606.585 163.828 606.155 164.258C605.725 164.688 606.298 165.979 606.585 166.695C606.871 167.412 607.588 166.695 608.305 165.979C609.022 165.262 608.735 164.832 608.735 164.258C608.735 163.685 609.308 164.832 609.308 165.405C609.308 165.979 609.739 165.979 610.599 166.695C611.459 167.412 611.315 167.126 611.889 167.842C612.462 168.559 612.892 168.846 613.896 168.846C614.899 168.846 614.899 168.416 614.899 167.126C614.899 165.835 613.753 165.979 613.322 165.979C612.892 165.979 613.322 164.832 612.462 164.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.28 164.832C644.706 165.405 644.288 165.262 643.857 164.832C642.854 165.357 640.646 166.552 639.843 167.126C638.84 167.842 639.987 168.416 640.56 169.419C641.134 170.423 641.564 168.846 642.137 168.416C642.711 167.986 642.567 167.842 643.857 167.842C645.148 167.842 645.291 167.842 646.008 167.126C646.725 166.409 646.868 166.695 647.298 166.695C647.728 166.695 648.158 167.556 648.875 167.842C649.592 168.129 649.735 167.556 649.735 166.695C649.735 165.835 650.308 166.265 651.025 165.979C651.742 165.692 650.022 164.832 649.735 164.258C649.448 163.685 648.732 163.255 647.728 163.112C646.725 162.968 646.008 163.398 646.008 164.258C646.008 165.119 645.853 164.258 645.28 164.832Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.462 164.258C611.774 163.8 611.411 164.45 611.315 164.832C611.077 164.497 610.599 163.771 610.599 163.542C610.599 163.255 609.308 162.538 609.308 162.108C609.308 161.678 608.735 162.682 607.732 162.538C606.728 162.395 606.585 163.828 606.155 164.258C605.725 164.688 606.298 165.979 606.585 166.695C606.871 167.412 607.588 166.695 608.305 165.979C609.022 165.262 608.735 164.832 608.735 164.258C608.735 163.685 609.308 164.832 609.308 165.405C609.308 165.979 609.739 165.979 610.599 166.695C611.459 167.412 611.315 167.126 611.889 167.842C612.462 168.559 612.892 168.846 613.896 168.846C614.899 168.846 614.899 168.416 614.899 167.126C614.899 165.835 613.753 165.979 613.322 165.979C612.892 165.979 613.322 164.832 612.462 164.258Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.329 182.321C615.1 182.092 614.947 180.697 614.899 180.028C616.711 179.76 618.818 179.604 621.026 179.527C621.123 179.061 621.237 178.708 621.35 178.594C621.569 178.376 622.993 178.878 624.42 179.469C626.389 179.466 628.36 179.513 630.202 179.588C630.625 179.102 631.135 178.594 631.959 178.594C632.985 178.594 632.918 179.063 632.826 179.718C636.729 179.947 639.604 180.278 639.843 180.458C640.302 180.802 640.035 182.799 639.843 183.755C639.557 183.659 638.783 183.353 637.98 182.895C637.523 182.634 635.312 182.581 632.769 182.614C632.598 183.344 632.279 184.009 631.959 184.328C631.385 184.902 630.382 183.755 630.382 184.328V187.052C630.382 187.74 631.433 194.064 631.959 195.976C629.522 196.119 624.648 195.89 624.648 195.545C624.648 195.115 625.221 190.636 625.364 187.625C625.477 185.255 626.479 183.615 626.69 182.799C625.86 182.835 625.152 182.869 624.648 182.895C624.274 182.913 623.843 182.922 623.377 182.923C622.199 183.243 621.113 183.518 620.92 183.325C620.85 183.254 620.802 183.09 620.774 182.863C618.155 182.752 615.515 182.507 615.329 182.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.14,
    cy: 133.494,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 635.14 133.494)",
    fill: "white"
  }))), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 678,
    width: 81,
    height: 10,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 681,
    cy: 683,
    r: 7,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 684,
    r: 10,
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.483 674C735.41 676.165 736 679.412 736 683.04C736 686.624 735.425 689.835 734.517 692C733.59 689.835 733 686.588 733 682.96C733 679.376 733.575 676.165 734.483 674Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.483 674C684.41 675.805 685 678.51 685 681.534C685 684.52 684.425 687.196 683.517 689C682.59 687.196 682 684.49 682 681.466C682 678.48 682.575 675.804 683.483 674Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M670.84 722.015C668.124 713.546 669.085 702.31 670.156 696.44C670.249 695.932 670.85 695.721 671.251 696.046L673.776 698.1C674.28 698.509 674.24 700.024 673.974 700.616C672.363 704.197 671.956 714.465 671.973 721.794C671.975 722.536 671.067 722.722 670.84 722.015Z",
    fill: "white",
    stroke: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M765.155 717.763C762.97 711.527 763.397 704.956 764.249 700.702C764.313 700.384 764.594 700.16 764.918 700.16H768.108C768.581 700.16 768.931 700.625 768.818 701.085C768.118 703.954 766.742 711.568 766.414 717.523C766.373 718.258 765.398 718.458 765.155 717.763Z",
    fill: "white",
    stroke: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M736.161 726.921C733.11 718.634 733.679 709.771 734.797 704.154C734.861 703.835 735.142 703.608 735.468 703.608H739.839C740.31 703.608 740.656 704.07 740.543 704.528C739.661 708.098 737.77 718.744 737.435 726.673C737.404 727.412 736.417 727.615 736.161 726.921Z",
    fill: "white",
    stroke: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M703.437 660.821C703.47 660.814 703.504 660.812 703.538 660.815L775.104 666.259C775.547 666.293 775.585 666.928 775.149 667.014L747.459 672.478C747.428 672.484 747.397 672.487 747.366 672.485L666.738 668.562C666.287 668.54 666.242 667.89 666.686 667.806L703.437 660.821L703.36 660.411L703.437 660.821Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.834369
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M665.602 682.368C665.648 681.462 666.456 680.778 667.363 680.877C698.192 684.243 716.555 685.111 747.898 684.929C748.809 684.923 749.542 685.685 749.497 686.589L748.583 704.725C748.539 705.597 747.797 706.267 746.926 706.224L666.187 702.156C665.316 702.112 664.645 701.37 664.689 700.499L665.602 682.368Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.834369
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M666.649 668.614C666.699 667.615 667.663 666.891 668.656 667.109C672.008 667.846 678.502 669.098 685.74 669.568C688.855 669.771 690.544 669.588 692.796 669.344C692.908 669.332 693.022 669.32 693.138 669.307C695.551 669.047 698.717 668.735 704.957 668.735C711.179 668.735 714.905 669.379 718.276 670.065C718.65 670.141 719.019 670.218 719.387 670.294C722.356 670.909 725.252 671.509 729.557 671.655C737.811 671.934 745.143 671.406 748.751 671.071C749.739 670.979 750.586 671.783 750.537 672.764L750.019 683.051C749.966 684.098 748.927 684.818 747.919 684.504C743.484 683.12 734.081 680.389 728.021 680.083C720.766 679.718 715.01 680.543 709.583 681.32C708.099 681.533 706.639 681.742 705.181 681.922C698.391 682.761 691.549 682.99 682.122 680.101C679.917 679.425 677.292 679.323 674.809 679.472C672.319 679.622 669.94 680.027 668.21 680.387C667.121 680.614 666.087 679.754 666.142 678.676L666.649 668.614Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.834369
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M709.846 562.761C709.873 562.325 710.082 561.914 710.42 561.637C734.174 542.106 763.772 549.083 786.098 568.343C786.292 568.51 786.393 568.761 786.371 569.016L777.861 665.217C777.824 665.645 777.453 665.967 777.023 665.944L704.501 662.034C704.058 662.011 703.72 661.63 703.747 661.187L709.846 562.761Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.242 561.332C699.548 556.689 701.719 557.503 704.449 558.526C705.007 558.735 705.589 558.953 706.225 559.135C708.413 559.76 710.844 561.118 711.8 561.68C712.058 561.832 712.201 562.119 712.176 562.417L704.123 658.688V661.663C704.123 662.064 703.825 662.403 703.427 662.455L672.126 666.524C671.628 666.589 671.194 666.183 671.225 665.682L671.515 661.017C671.54 660.612 671.256 660.258 670.868 660.137C667.927 659.216 665.751 655.925 665.751 652.005C665.751 647.372 668.791 643.617 672.541 643.617C672.85 643.617 673.154 643.642 673.452 643.692C673.499 643.699 673.546 643.704 673.593 643.704H688.4C688.817 643.704 689.163 643.388 689.196 642.973C690.423 627.43 692.16 605.011 692.644 596.683C692.934 591.698 692.389 586.431 691.876 581.472C690.968 572.706 690.16 564.904 694.242 561.332Z",
    fill: "black"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-361-inside-3_3713_17473",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.578 562.484C780.774 558.01 788.701 564.938 790.279 566.412C790.459 566.581 790.539 566.822 790.508 567.067L778.068 665.201C778.016 665.617 777.65 665.921 777.232 665.898L775.507 665.802C775.05 665.777 774.664 666.141 774.664 666.6V667.98C774.664 668.421 774.307 668.779 773.865 668.779H757.098C756.872 668.779 756.689 668.596 756.689 668.37C756.689 668.131 756.485 667.943 756.247 667.962C756.087 667.975 755.925 667.988 755.762 668C751.255 668 746 661.669 746 659.53C746 649.725 753.544 649 758.05 649C759.403 649 760.679 649.316 761.802 649.876C762.32 650.134 762.983 649.868 763.093 649.3C765.985 634.47 770.077 612.89 771.584 602.029C772.514 595.321 772.418 588.473 772.331 582.345C772.201 573.093 772.094 565.485 775.578 562.484Z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.578 562.484C780.774 558.01 788.701 564.938 790.279 566.412C790.459 566.581 790.539 566.822 790.508 567.067L778.068 665.201C778.016 665.617 777.65 665.921 777.232 665.898L775.507 665.802C775.05 665.777 774.664 666.141 774.664 666.6V667.98C774.664 668.421 774.307 668.779 773.865 668.779H757.098C756.872 668.779 756.689 668.596 756.689 668.37C756.689 668.131 756.485 667.943 756.247 667.962C756.087 667.975 755.925 667.988 755.762 668C751.255 668 746 661.669 746 659.53C746 649.725 753.544 649 758.05 649C759.403 649 760.679 649.316 761.802 649.876C762.32 650.134 762.983 649.868 763.093 649.3C765.985 634.47 770.077 612.89 771.584 602.029C772.514 595.321 772.418 588.473 772.331 582.345C772.201 573.093 772.094 565.485 775.578 562.484Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M775.578 562.484L774.926 561.727V561.727L775.578 562.484ZM755.762 668V669H755.8L755.838 668.997L755.762 668ZM771.584 602.029L772.574 602.166L771.584 602.029ZM772.331 582.345L773.331 582.331L772.331 582.345ZM761.802 649.876L762.248 648.981L761.802 649.876ZM756.247 667.962L756.168 666.965L756.247 667.962ZM775.507 665.802L775.563 664.804L775.507 665.802ZM778.068 665.201L779.06 665.327L778.068 665.201ZM777.232 665.898L777.176 666.896L777.232 665.898ZM790.279 566.412L789.596 567.142L790.279 566.412ZM790.508 567.067L789.516 566.941L790.508 567.067ZM790.961 565.681C790.15 564.923 787.685 562.739 784.718 561.316C781.789 559.911 777.994 559.084 774.926 561.727L776.231 563.242C778.358 561.41 781.124 561.81 783.853 563.119C786.543 564.41 788.83 566.427 789.596 567.142L790.961 565.681ZM779.06 665.327L791.5 567.193L789.516 566.941L777.076 665.075L779.06 665.327ZM775.452 666.801L777.176 666.896L777.287 664.9L775.563 664.804L775.452 666.801ZM773.664 666.6V667.98H775.664V666.6H773.664ZM773.865 667.779H757.098V669.779H773.865V667.779ZM755.838 668.997C756.003 668.985 756.165 668.972 756.327 668.959L756.168 666.965C756.009 666.978 755.848 666.991 755.686 667.003L755.838 668.997ZM745 659.53C745 659.98 745.132 660.449 745.307 660.882C745.488 661.329 745.741 661.806 746.045 662.289C746.654 663.255 747.502 664.306 748.489 665.28C750.414 667.177 753.1 669 755.762 669V667C753.917 667 751.722 665.658 749.893 663.855C749.003 662.978 748.256 662.046 747.738 661.223C747.479 660.812 747.287 660.443 747.162 660.134C747.032 659.811 747 659.615 747 659.53H745ZM758.05 648C755.781 648 752.533 648.173 749.837 649.721C747.036 651.33 745 654.319 745 659.53H747C747 654.936 748.735 652.66 750.833 651.455C753.036 650.19 755.814 650 758.05 650V648ZM762.248 648.981C760.989 648.353 759.56 648 758.05 648V650C759.246 650 760.369 650.279 761.356 650.771L762.248 648.981ZM770.593 601.891C769.091 612.72 765.005 634.271 762.112 649.109L764.075 649.492C766.965 634.67 771.063 613.061 772.574 602.166L770.593 601.891ZM771.332 582.359C771.418 588.498 771.511 595.271 770.593 601.891L772.574 602.166C773.517 595.371 773.417 588.447 773.331 582.331L771.332 582.359ZM774.926 561.727C772.876 563.491 772.002 566.487 771.606 569.957C771.205 573.468 771.267 577.755 771.332 582.359L773.331 582.331C773.266 577.683 773.209 573.54 773.593 570.184C773.981 566.786 774.796 564.477 776.231 563.242L774.926 561.727ZM761.356 650.771C762.363 651.273 763.817 650.816 764.075 649.492L762.112 649.109C762.118 649.077 762.134 649.044 762.156 649.018C762.177 648.994 762.195 648.984 762.205 648.98C762.217 648.974 762.231 648.973 762.248 648.981L761.356 650.771ZM757.689 668.37C757.689 667.545 756.985 666.9 756.168 666.965L756.327 668.959C755.985 668.986 755.689 668.717 755.689 668.37H757.689ZM773.664 667.98C773.664 667.869 773.754 667.779 773.865 667.779V669.779C774.859 669.779 775.664 668.973 775.664 667.98H773.664ZM775.563 664.804C774.532 664.746 773.664 665.567 773.664 666.6H775.664C775.664 666.715 775.567 666.807 775.452 666.801L775.563 664.804ZM777.076 665.075C777.09 664.97 777.182 664.894 777.287 664.9L777.176 666.896C778.119 666.949 778.942 666.263 779.06 665.327L777.076 665.075ZM757.098 667.779C757.425 667.779 757.689 668.043 757.689 668.37H755.689C755.689 669.148 756.32 669.779 757.098 669.779V667.779ZM789.596 567.142C789.526 567.077 789.509 566.992 789.516 566.941L791.5 567.193C791.569 566.651 791.393 566.084 790.961 565.681L789.596 567.142Z",
    fill: "white",
    mask: "url(#path-361-inside-3_3713_17473)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M752.1 655.927C752.138 655.405 752.574 655 753.098 655H777C777.552 655 778 655.448 778 656V667.117C778 667.627 777.617 668.055 777.11 668.111L752.195 670.868C751.573 670.937 751.042 670.425 751.088 669.801L752.1 655.927Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M750.338 672.426C750.389 671.695 750.936 671.096 751.659 670.977L777.196 666.8C778.195 666.637 779.087 667.442 779.028 668.452L777.274 698.222C777.233 698.922 776.736 699.511 776.053 699.668L750.048 705.683C749.013 705.923 748.041 705.093 748.115 704.033L750.338 672.426Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.834369
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.277 746.105C632.242 746.105 623.342 757.914 602.042 757.914C579.375 757.914 561 751.933 561 744.556C561 739.019 571.35 734.269 586.096 732.244C591.975 730.23 581.908 728.47 581.908 726.358C581.908 718.981 600.283 713 622.95 713C645.617 713 663.992 718.981 663.992 726.358C663.992 728.104 662.963 729.771 661.092 731.3C656.441 733.715 677.543 735.736 677.543 740.297C677.543 745.322 668.876 749.396 658.184 749.396C651.963 749.396 647.923 746.105 643.277 746.105ZM639.086 738.798L638.895 738.67L639.146 738.636L639.086 738.798Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.6156,
    ry: 4.45265,
    transform: "matrix(1 0 0 -1 682.964 729.456)",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.13092,
    ry: 3.09749,
    transform: "matrix(1 0 0 -1 691.869 741.652)",
    fill: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1043.82,
    y1: 465.747,
    x2: 1198.82,
    y2: 567.747,
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3713_17473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 27,
    width: 118,
    height: 151
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 27.0001,
    width: 118,
    height: 150.694,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3713_17473)"
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M400.853 91.0734C403.296 89.946 405.864 83.3069 406.49 80.1753C410.418 88.5039 418.421 88.5529 420.716 87.2467C420.966 86.2233 421.202 85.7156 421.334 86.3759C421.395 86.6835 421.165 86.991 420.716 87.2467C420.254 89.1352 419.743 92.7799 419.743 94.0798L411.663 97.0861C408.845 96.1466 399.261 91.808 400.853 91.0734Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M417.986 56.7119C416.671 56.3361 413.665 56.0355 412.162 57.8393C410.283 60.0941 408.779 61.2215 407.652 66.8584C406.75 71.368 403.894 71.9943 402.579 71.7438C402.704 73.1217 404.761 78.8976 406.114 80.5511C407.805 82.618 404.389 87.3154 402.92 88.067C401.451 88.8186 397.095 89.946 393.901 86.188C390.707 82.4301 389.426 78.696 390.929 77.9444C392.132 77.3431 391.555 77.4433 391.117 77.5686C390.24 76.4412 389.013 73.6979 391.117 71.7438C393.748 69.3011 393.56 68.1737 394.499 66.8584C394.75 64.9168 395.815 60.3947 398.069 57.8393C400.888 54.645 402.015 52.954 403.706 52.7661C405.397 52.5782 409.531 49.0081 416.483 51.6387C417.49 52.0197 418.241 52.3161 418.786 52.5432C420.306 52.1705 422.557 51.8873 423.436 52.7661C424.751 54.0814 427.569 55.9603 427.193 59.5304C426.818 63.1005 427.757 66.2947 427.193 66.8584C426.743 67.3094 426.129 67.0463 425.878 66.8584C425.941 65.1673 425.841 61.5221 424.939 60.4699C423.811 59.1546 422.496 56.7119 420.241 56.7119H417.986Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M400.102 90.1347C401.304 90.2851 406.365 93.4543 408.745 95.0201C409.747 93.3916 411.977 90.1347 412.879 90.1347C414.006 90.1347 421.522 88.2557 424.904 86.7526C428.286 85.2494 430.917 88.6315 435.051 90.1347C439.184 91.6379 437.681 96.3354 438.057 98.2143C438.433 100.093 440.312 110.616 442.379 112.87C444.446 115.125 445.009 126.775 450.458 132.412C455.907 138.049 458.35 155.711 459.477 157.966C460.605 160.221 466.993 162.288 468.872 166.421C470.376 169.728 464.488 177.946 461.356 181.641H353.503C357.825 181.453 363.649 164.354 366.28 162.288C368.911 160.221 366.656 143.31 366.28 140.679C365.904 138.049 370.602 123.581 373.232 119.635C375.863 115.689 385.446 107.985 385.634 107.046C385.821 106.106 389.391 97.4628 392.022 95.0201C394.653 92.5774 398.598 89.9468 400.102 90.1347Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M412.899 137.801C413.035 138.406 414.709 138.095 415.529 137.863C415.035 139.656 410.759 140.883 408.682 141.273C396.825 141.932 397.121 145.322 394.42 148.265C391.719 151.209 392.212 154.227 390.857 155.887C389.773 157.214 386.487 157.851 384.98 158.003C386.004 157.088 387.551 155.809 385.544 158.017C383.035 160.777 382.553 165.276 381.39 166.752C380.46 167.933 378.561 169.818 377.728 170.612C377.521 171.422 376.872 173.411 375.935 174.893C374.763 176.745 370.922 180.225 369.008 181.683C367.094 183.141 365.949 183.866 364.796 184.967C363.642 186.067 338.51 183.781 339.262 183.799C340.013 183.816 341.377 181.781 343.461 181.079C345.545 180.376 358.515 148.543 358.904 147.989C359.293 147.434 364.345 132.518 364.971 129.901C365.471 127.808 373.532 108.378 377.728 100.521C377.697 101.836 373.315 112.055 372.702 114.108C372.212 115.751 369.412 120.546 368.23 122.836C368.274 120.958 369.386 118.397 370.595 114.622C382.627 77.0338 389.385 74.6967 392.962 66.5115C396.538 58.3262 394.116 57.8537 398.914 53.6444C402.753 50.2769 409.354 48.5144 412.899 49.6006C417.407 49.7073 421.509 49.3894 426.129 52.6939C430.75 55.9983 433.485 70.0621 435.672 72.9331C437.859 75.8042 442.651 87.7584 443.506 91.3497C444.361 94.941 451.556 116.538 453.332 120.902C455.108 125.267 459.122 138.331 461.484 141.77C463.846 145.209 465.923 152.776 466.612 155.424C467.301 158.071 465.066 165.16 465.567 167.804C466.068 170.447 464.079 175.099 463.847 176.973C463.661 178.472 462.171 176.306 461.449 175.036C459.993 173.047 456.985 162.463 455.663 157.42L446.482 132.393M412.899 137.801C412.729 137.045 419.589 133.073 420.349 132.715C421.11 132.357 427.934 129.887 434.285 131.541C439.366 132.864 444.534 132.66 446.482 132.393M412.899 137.801C413.206 132.521 413.008 119.797 412.008 111.203C410.759 100.461 409.536 88.5907 411.123 85.0572M446.482 132.393C443.292 124.461 436.559 105.92 435.145 95.211C433.378 81.8247 426.854 63.6271 426.129 62.4822M396.224 71.9999C393.329 85.5882 387.772 117.154 388.71 134.71",
    stroke: "#070707",
    strokeWidth: 0.375796
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.9651C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.491C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.9651C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.491C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    stroke: "#171717",
    strokeWidth: 0.375796
  }))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.928 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.872 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.663C435.427 163.038 432.233 165.63 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.311 431.857 163.751 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.717C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M430.542 158.717C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.928 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.872 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.663C435.427 163.038 432.233 165.63 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.311 431.857 163.751 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.717ZM430.542 158.717C430.542 158.153 431.481 156.798 432.608 156.423",
    stroke: "black",
    strokeWidth: 0.375796
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M424.875 58.315C424.274 55.9099 420.866 56.1855 419.238 56.6239C418.361 56.1228 415.931 55.2335 413.225 55.6844C409.843 56.2481 409.092 59.4424 408.528 61.1335C407.964 62.8246 408.528 64.7035 407.4 67.1462C406.499 69.1003 404.144 70.0899 403.079 70.3405C399.509 69.401 402.139 75.2258 402.515 76.5411C402.816 77.5933 404.269 77.8564 404.958 77.8564L407.4 81.4906C407.651 82.5554 412.654 87.2403 417.013 87.6912C422.462 88.2549 422.092 85.5536 422.462 84.8728C423.243 83.4337 424.028 82.4301 424.529 81.8664C424.905 78.9853 425.1 77.2817 426.002 75.4779C427.13 73.2231 426.566 69.2146 426.002 67.9619C425.752 67.7114 425.852 65.6054 426.002 64.7035C426.19 63.5761 425.627 61.3214 424.875 58.315Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M415.134 81.4905C416.261 80.9895 418.629 80.0625 419.08 80.3632C419.643 80.7389 419.831 80.9269 420.207 80.9269C420.583 80.9269 420.771 80.3632 421.147 80.3632C421.522 80.3632 422.274 80.739 422.462 80.9269M417.952 82.2421C418.391 82.6179 419.455 83.2568 420.207 82.8058C420.959 82.3549 421.147 82.1169 421.147 82.0542",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M424.905 65.7622C423.84 65.5743 421.485 65.7622 420.583 68.017C419.681 70.2718 420.959 74.9066 421.898 76.0966",
    stroke: "black",
    strokeWidth: 0.375796
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M416.261 70.4046C415.572 69.4651 413.142 68.1498 408.933 70.4046M420.77 70.4046C421.021 69.1519 422.123 67.0224 424.528 68.5256",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.503,
    cy: 70.0288,
    r: 0.93949,
    fill: "#0B0F21"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.273,
    cy: 69.2773,
    r: 0.93949,
    fill: "#0B0F21"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3713_17473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.898 76.0965C421.835 76.7229 421.71 77.036 420.958 77.2239C420.229 77.4062 420.019 77.2239 419.455 76.981C418.891 76.738 417.388 77.7326 417.2 76.981M416.825 68.1498C416.261 67.5234 414.607 66.3084 412.503 66.4587C410.398 66.609 408.87 68.0245 408.369 68.7135",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M401.639 105.228C400.073 98.8649 392.656 97.274 389.143 97.274C385.379 99.3252 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.161 386.884 172.466 385.228 183.122C384.174 185.974 395.165 183.422 397.122 183.122C399.08 182.822 405.554 175.918 409.017 170.065C412.48 164.211 421.061 159.559 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.653 416.575 143.5 416.093 141.699C415.491 139.448 409.318 126.24 408.113 123.839C406.909 121.438 403.596 113.183 401.639 105.228Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M385.228 183.122C384.174 185.974 395.165 183.422 397.122 183.122C399.08 182.822 405.554 175.918 409.017 170.065C412.48 164.211 421.061 159.559 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.653 416.575 143.5 416.093 141.699C415.491 139.448 409.318 126.24 408.113 123.839C406.909 121.438 403.596 113.183 401.639 105.228C400.073 98.8649 392.656 97.274 389.143 97.274C385.379 99.3252 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.161 386.884 172.466 385.228 183.122ZM385.228 183.122C386.282 180.27 391.1 179.22 392.756 177.119C394.412 175.017 396.219 172.466 397.122 170.065",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M420.025 171.104C419.667 170.141 416.799 166.888 415.41 165.383C414.099 164.66 410.894 168.494 409.455 170.502C408.264 173.273 410.546 176.475 411.837 177.729C410.646 181.223 412.928 181.694 414.219 181.494C415.171 182.819 416.501 182.447 417.047 182.096C419.429 183.903 420.322 182.447 420.471 181.494C421.166 182.146 422.704 183.06 423.3 181.494C424.044 179.536 420.471 172.309 420.025 171.104Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 67.0001,
    width: 107,
    height: 26,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.5,
    cy: 74.5001,
    rx: 33.5,
    ry: 10.5,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281,
    cy: 85.5001,
    rx: 19,
    ry: 5.5,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 57.3809,
    rx: 11.5197,
    ry: 5.19514,
    fill: "#C4C4C4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M272.698 71.2346C269.913 69.0511 266.374 61.9737 265.771 57.5315C266.449 52.7881 268.03 53.3151 269.009 50.7552C269.792 48.7073 267.177 46.4385 265.771 45.5601H288.811C287.004 46.2126 285.031 48.1652 285.573 50.7552C286.115 53.3452 288.811 54.2939 288.811 57.5315C288.269 63.4946 284.118 69.1515 282.11 71.2346C280.077 71.8369 275.074 73.0969 272.698 71.2346Z",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 71.1593,
    rx: 4.74339,
    ry: 1.50584,
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M288.388 45.1631C288.388 45.1631 288.388 45.1639 288.387 45.1657C288.388 45.1639 288.388 45.1631 288.388 45.1631ZM288.311 45.1115C288.347 45.1442 288.366 45.1682 288.377 45.1836C288.366 45.199 288.347 45.223 288.311 45.2557C288.213 45.3461 288.04 45.4569 287.771 45.5767C287.236 45.8149 286.43 46.0415 285.397 46.2362C283.337 46.624 280.471 46.8671 277.29 46.8671C274.11 46.8671 271.243 46.624 269.184 46.2362C268.15 46.0415 267.345 45.8149 266.81 45.5767C266.541 45.4569 266.368 45.3461 266.269 45.2557C266.234 45.223 266.214 45.199 266.204 45.1836C266.214 45.1682 266.234 45.1442 266.269 45.1115C266.368 45.0211 266.541 44.9103 266.81 44.7905C267.345 44.5523 268.15 44.3257 269.184 44.131C271.243 43.7432 274.11 43.5001 277.29 43.5001C280.471 43.5001 283.337 43.7432 285.397 44.131C286.43 44.3257 287.236 44.5523 287.771 44.7905C288.04 44.9103 288.213 45.0211 288.311 45.1115ZM266.193 45.1631C266.193 45.1631 266.193 45.1639 266.193 45.1657C266.193 45.1639 266.192 45.1631 266.193 45.1631ZM266.193 45.2041C266.192 45.2041 266.193 45.2032 266.193 45.2015C266.193 45.2032 266.193 45.2041 266.193 45.2041ZM288.387 45.2015C288.388 45.2032 288.388 45.2041 288.388 45.2041C288.388 45.2041 288.388 45.2032 288.387 45.2015Z",
    fill: "white",
    stroke: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.325,
    cy: 64.2325,
    r: 6.32452,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.607,
    cy: 66.6418,
    r: 5.52336,
    fill: "white",
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.189,
    cy: 67.1688,
    r: 4.99631,
    fill: "white",
    stroke: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.619,
    cy: 65.136,
    r: 8.98679,
    fill: "#FFFDFD",
    stroke: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.479,
    cy: 65.136,
    r: 8.98679,
    fill: "#FFFDFD",
    stroke: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M277.218 70.5144C277.304 70.9527 277.447 71.5656 277.642 72.2783M280.133 78.4448C281.727 81.0493 283.289 81.5629 283.871 81.4942M280.133 78.4448C280.674 79.6452 281.738 82.3503 281.661 83.5676M280.133 78.4448C280.19 78.6372 279.867 79.0271 278.113 79.0473M280.133 78.4448C279.773 77.8563 279.442 77.2085 279.143 76.5401M279.143 76.5401C279.733 76.9927 281.132 77.8954 282.009 77.8853M279.143 76.5401C278.723 75.6036 278.365 74.6269 278.071 73.717M278.071 73.717C279.179 73.8056 281.57 73.8836 282.268 73.4866M278.071 73.717C277.908 73.2106 277.765 72.7249 277.642 72.2783M277.642 72.2783C277.453 73.1975 276.626 75.1693 274.837 75.703",
    stroke: "#505050",
    strokeWidth: 0.292857,
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M283.719 84.8397C284.225 86.537 283.285 88.2972 281.646 88.7859C280.007 89.2747 278.257 88.3169 277.75 86.6196C277.244 84.9223 278.184 83.1621 279.823 82.6733C281.462 82.1846 283.212 83.1424 283.719 84.8397Z",
    fill: "white",
    stroke: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M286.421 77.041C286.82 78.3818 286.082 79.763 284.804 80.1442C283.525 80.5254 282.151 79.7744 281.751 78.4336C281.351 77.0928 282.09 75.7115 283.368 75.3304C284.646 74.9492 286.021 75.7002 286.421 77.041Z",
    fill: "white",
    stroke: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M285.933 70.6651C286.44 72.3624 285.5 74.1226 283.861 74.6113C282.222 75.1001 280.471 74.1423 279.965 72.445C279.459 70.7477 280.399 68.9875 282.038 68.4988C283.677 68.01 285.427 68.9678 285.933 70.6651Z",
    fill: "white",
    stroke: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M293.714 76.2018C294.22 77.8991 293.28 79.6593 291.641 80.1481C290.002 80.6368 288.252 79.6791 287.745 77.9818C287.239 76.2845 288.179 74.5243 289.818 74.0355C291.457 73.5468 293.208 74.5045 293.714 76.2018Z",
    fill: "white",
    stroke: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M272.186 80.4218C272.693 82.1191 271.753 83.8793 270.114 84.3681C268.475 84.8568 266.724 83.899 266.218 82.2017C265.712 80.5044 266.652 78.7442 268.291 78.2555C269.93 77.7667 271.68 78.7245 272.186 80.4218Z",
    fill: "white",
    stroke: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M289.118 81.3434C289.624 83.0407 288.684 84.8009 287.045 85.2897C285.407 85.7784 283.656 84.8207 283.15 83.1234C282.644 81.4261 283.584 79.6659 285.222 79.1771C286.861 78.6884 288.612 79.6461 289.118 81.3434Z",
    fill: "white",
    stroke: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M290.646 73.8169C291.081 75.2765 290.275 76.7841 288.877 77.2012C287.478 77.6182 285.978 76.7982 285.543 75.3387C285.108 73.8791 285.914 72.3715 287.312 71.9544C288.71 71.5374 290.21 72.3574 290.646 73.8169Z",
    fill: "white",
    stroke: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M295.664 69.5702C296.324 71.7835 295.092 74.0903 292.933 74.7342C290.775 75.378 288.48 74.1229 287.82 71.9096C287.16 69.6963 288.392 67.3895 290.551 66.7457C292.71 66.1018 295.004 67.3569 295.664 69.5702Z",
    fill: "white",
    stroke: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M275.671 75.7687C276.177 77.466 275.237 79.2262 273.598 79.715C271.959 80.2037 270.209 79.246 269.702 77.5487C269.196 75.8514 270.136 74.0912 271.775 73.6024C273.414 73.1137 275.165 74.0714 275.671 75.7687Z",
    fill: "white",
    stroke: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M270.398 76.0053C270.798 77.3462 270.059 78.7274 268.781 79.1086C267.503 79.4897 266.128 78.7388 265.729 77.398C265.329 76.0571 266.067 74.6759 267.345 74.2947C268.624 73.9136 269.998 74.6645 270.398 76.0053Z",
    fill: "white",
    stroke: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M279.132 80.0004C279.721 81.9754 278.624 84.03 276.705 84.6023C274.786 85.1746 272.743 84.0566 272.154 82.0816C271.565 80.1065 272.662 78.0519 274.581 77.4796C276.5 76.9073 278.543 78.0253 279.132 80.0004Z",
    fill: "white",
    stroke: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.832,
    cy: 75.6015,
    r: 5.6469,
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M354.39 467.081L381.674 459.032C382.518 458.783 383.421 459.115 383.908 459.852L397.163 479.93C394.746 477.186 391.255 475.364 388.674 474.454C385.239 473.241 382.972 473.528 381.463 476.535C381.457 476.507 381.452 476.479 381.447 476.451C381.026 474.178 380.566 471.693 376.7 470.819C373.078 469.999 370.911 471.631 368.739 473.267C368.266 473.623 367.793 473.979 367.305 474.31C366.57 472.036 365.367 470.855 363.83 470.313C361.235 469.397 358.89 469.379 356.794 470.293C356.287 469.092 355.465 467.984 354.39 467.081Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M360.523 469.869L348.418 443.912C348.044 443.109 347.199 442.646 346.328 442.766L322.647 446.05C326.284 446.059 329.949 447.491 332.335 448.839C335.511 450.632 336.801 452.535 335.569 455.669C335.593 455.655 335.618 455.64 335.642 455.625C337.608 454.437 339.757 453.139 342.967 455.481C345.975 457.677 346.2 460.396 346.425 463.122C346.474 463.715 346.523 464.309 346.601 464.897C348.776 463.946 350.45 464.073 351.87 464.875C354.269 466.23 355.836 467.99 356.547 470.18C357.774 469.768 359.141 469.656 360.523 469.869Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M361.262 459.948C363.193 460.826 365.531 460.147 367.449 458.404C367.437 459.805 367.116 461.317 366.457 462.794C366.052 463.702 365.551 464.523 364.986 465.238L354.237 479.558C353.196 480.944 351.028 479.958 351.367 478.252L354.842 460.802C354.993 459.849 355.279 458.871 355.709 457.907C356.368 456.431 357.277 455.186 358.309 454.249C358.286 456.853 359.332 459.071 361.262 459.948Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M947.749 103.551C943.52 105.274 933.762 111.499 932 113V120H1011V107.5L1005.71 105.901C999.055 103.943 988.872 99.2429 987.305 96.1097C985.739 92.9766 964.394 94.3473 964.003 95.3264C963.689 96.1097 960.739 98.2638 959.303 99.2429C957.214 99.9609 951.979 101.828 947.749 103.551Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M988.48 53.6163C991.744 55.9009 998.232 61.9584 998.076 67.9114C997.88 75.3526 997.88 73.9819 996.117 77.3108C994.355 80.6398 992.788 83.773 992.788 85.7312C992.788 87.6894 990.634 91.9975 987.893 91.9975C985.151 91.9975 986.522 95.5223 984.564 96.3056C983.99 96.5349 982.293 96.9993 980.06 97.3939C979.704 97.4798 979.363 97.535 979.035 97.5636C975.075 98.1751 969.876 98.4684 966.156 97.0379C964.81 96.5199 963.657 95.7759 962.827 94.739C958.178 88.9278 957.937 88.0986 956.605 83.5321L956.561 83.3813C955.19 78.6816 954.603 77.7025 954.799 75.1568C954.211 74.5041 953.036 72.8853 953.036 71.632C953.036 70.0654 953.624 69.0863 953.624 68.4988C953.624 67.9114 950.686 67.3239 951.861 66.149C953.036 64.974 954.211 64.3866 954.799 62.0367C955.386 59.6868 955.974 56.7495 955.778 55.1829C956.822 54.3996 959.107 53.1464 959.89 54.3996C960.869 55.9662 987.501 56.162 988.48 53.6163Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M966.156 97.0379C964.81 96.5199 963.657 95.7759 962.827 94.739C958.128 88.8644 957.932 88.0811 956.561 83.3813C955.19 78.6816 954.603 77.7025 954.799 75.1568C954.211 74.5041 953.036 72.8853 953.036 71.632C953.036 70.0654 953.624 69.0863 953.624 68.4988C953.624 67.9114 950.686 67.3239 951.861 66.149C953.036 64.974 954.211 64.3866 954.799 62.0367C955.386 59.6868 955.974 56.7495 955.778 55.1829C956.822 54.3996 959.107 53.1464 959.89 54.3996C960.869 55.9662 987.501 56.162 988.48 53.6163C991.744 55.9009 998.232 61.9584 998.076 67.9114C997.88 75.3526 997.88 73.9819 996.117 77.3108C994.355 80.6398 992.788 83.773 992.788 85.7312C992.788 87.6894 990.634 91.9975 987.893 91.9975C985.151 91.9975 986.522 95.5223 984.564 96.3056C983.99 96.5349 982.293 96.9993 980.06 97.3939M966.156 97.0379C967.704 97.0936 970.711 96.6123 973.611 94.739M966.156 97.0379C970.207 98.5957 976.012 98.1093 980.06 97.3939M973.611 94.739C974.259 95.9867 976.457 98.2645 980.06 97.3939M973.611 94.739C974.699 94.0362 975.772 93.1374 976.746 91.9975M963.807 85.7312C965.7 88.7338 971.091 93.9949 977.514 91.0184C977.266 91.363 977.01 91.6891 976.746 91.9975M976.746 91.9975C978.569 92.7155 982.997 92.4675 986.13 85.7312",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M976.732 45.1773C968.272 43.7674 962.11 51.1173 960.087 54.9684C956.17 61.6264 958.716 70.2426 960.087 75.9214C961.458 81.6003 964.199 90.4123 975.949 90.4123C987.698 90.4123 987.502 80.817 991.418 70.6342C995.335 60.4515 991.418 54.9684 989.069 49.6812C987.189 45.4514 980.061 44.9162 976.732 45.1773Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M976.732 47.35C975.471 52.0497 973.25 62.7808 974.449 68.1072M974.449 49.6812C970.684 50.0791 962.54 52.4414 960.087 58.7077M976.732 49.6812C980.518 50.2749 988.575 52.3239 990.507 55.7704M960.087 54.9684C962.11 51.1173 968.272 43.7674 976.732 45.1773C980.061 44.9162 987.189 45.4514 989.069 49.6812C991.418 54.9684 995.335 60.4515 991.418 70.6342C987.502 80.817 987.698 90.4123 975.949 90.4123C964.199 90.4123 961.458 81.6003 960.087 75.9214C958.716 70.2426 956.17 61.6264 960.087 54.9684Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M983.666 79.2612C984.026 78.272 985.187 76.33 986.953 76.4758C988.001 76.5622 988.453 76.5995 988.609 76.6124C988.609 76.6124 988.609 76.6124 988.609 76.6124C988.684 76.6186 988.716 76.6213 988.609 76.6124C988.901 77.5628 988.825 79.7147 986.186 80.7196C983.547 81.7244 983.407 80.166 983.666 79.2612Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M980.005 79.6709C980.798 78.9783 982.752 77.8381 984.228 78.8187C985.104 79.4003 985.482 79.6513 985.612 79.738C985.612 79.738 985.612 79.738 985.612 79.7379C985.675 79.7795 985.702 79.7974 985.612 79.738C985.409 80.7112 984.304 82.5591 981.507 82.1646C978.711 81.77 979.341 80.3378 980.005 79.6709Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M975.201 80.1621C976.115 79.6399 978.256 78.9088 979.51 80.1621C980.253 80.9054 980.574 81.2263 980.685 81.337C980.685 81.337 980.685 81.337 980.685 81.337C980.738 81.3901 980.76 81.413 980.685 81.337C980.293 82.2508 978.844 83.8435 976.181 82.9036C973.517 81.9636 974.418 80.6843 975.201 80.1621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M971.306 79.4623C972.247 79.1058 974.38 78.7364 975.375 80.1107C975.965 80.9259 976.219 81.2777 976.307 81.3992C976.307 81.3992 976.307 81.3992 976.307 81.3992C976.349 81.4575 976.368 81.4825 976.307 81.3992C975.8 82.2049 974.191 83.4937 971.817 82.2035C969.443 80.9134 970.487 79.8385 971.306 79.4623Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M967.368 79.3788C968.282 78.8566 970.423 78.1255 971.677 79.3788C972.42 80.1221 972.741 80.4429 972.851 80.5537C972.851 80.5537 972.851 80.5537 972.851 80.5537C972.905 80.6068 972.927 80.6297 972.851 80.5537C972.46 81.4675 971.011 83.0602 968.348 82.1203C965.684 81.1803 966.585 79.9009 967.368 79.3788Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M961.606 80.4132C960.65 79.7908 960.623 78.0612 960.729 77.2742C960.717 77.1588 960.798 76.9454 961.219 77.0153C961.567 77.0508 962.051 77.1532 962.551 77.3476C963.902 77.1753 966.891 77.4929 968.042 80.1425C967.288 80.9554 965.272 82.152 963.239 80.435C962.67 80.6476 962.07 80.7151 961.606 80.4132Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M962.551 77.3476C962.051 77.1532 961.567 77.0508 961.219 77.0153C960.798 76.9454 960.717 77.1588 960.729 77.2742C960.623 78.0612 960.65 79.7908 961.606 80.4132C962.07 80.7151 962.67 80.6476 963.239 80.435M962.551 77.3476C963.478 77.7079 964.461 78.3842 964.745 79.5364C964.411 79.8204 963.842 80.2094 963.239 80.435M962.551 77.3476C963.902 77.1753 966.891 77.4929 968.042 80.1425C967.288 80.9554 965.272 82.152 963.239 80.435",
    stroke: "black",
    strokeWidth: 0.5
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M983.287 81.8916C983.623 81.0236 984.707 79.3195 986.358 79.4474C987.337 79.5233 987.76 79.556 987.906 79.5673C987.906 79.5673 987.906 79.5673 987.906 79.5673C987.976 79.5727 988.006 79.5751 987.906 79.5673C988.179 80.4013 988.108 82.2896 985.641 83.1713C983.175 84.0531 983.044 82.6856 983.287 81.8916Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M979.865 82.2511C980.605 81.6433 982.432 80.6428 983.812 81.5033C984.63 82.0136 984.983 82.2339 985.105 82.3099C985.105 82.3099 985.105 82.3099 985.105 82.3099C985.164 82.3464 985.189 82.3621 985.105 82.3099C984.915 83.1639 983.882 84.7854 981.269 84.4393C978.655 84.0931 979.244 82.8362 979.865 82.2511Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M975.376 82.682C976.23 82.2238 978.231 81.5823 979.402 82.682C980.097 83.3343 980.397 83.6159 980.5 83.713C980.5 83.713 980.5 83.713 980.5 83.713C980.55 83.7596 980.571 83.7797 980.5 83.713C980.134 84.5149 978.78 85.9125 976.291 85.0877C973.802 84.2629 974.643 83.1403 975.376 82.682Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M971.734 82.068C972.615 81.7552 974.608 81.431 975.538 82.637C976.089 83.3523 976.327 83.661 976.409 83.7676C976.409 83.7676 976.409 83.7676 976.409 83.7676C976.449 83.8187 976.466 83.8407 976.409 83.7676C975.935 84.4746 974.431 85.6055 972.213 84.4734C969.994 83.3413 970.969 82.3981 971.734 82.068Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M968.054 81.9947C968.908 81.5364 970.909 80.8949 972.081 81.9947C972.775 82.647 973.075 82.9285 973.179 83.0257C973.179 83.0257 973.179 83.0257 973.179 83.0257C973.228 83.0723 973.25 83.0923 973.179 83.0257C972.813 83.8276 971.458 85.2251 968.969 84.4003C966.48 83.5755 967.322 82.4529 968.054 81.9947Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M962.668 82.9023C961.775 82.3562 961.749 80.8385 961.848 80.1479C961.837 80.0466 961.912 79.8593 962.306 79.9207C962.631 79.9518 963.083 80.0417 963.551 80.2123C964.814 80.0611 967.607 80.3398 968.683 82.6648C967.979 83.3782 966.095 84.4282 964.194 82.9215C963.662 83.108 963.101 83.1673 962.668 82.9023Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M963.551 80.2123C963.083 80.0417 962.631 79.9518 962.306 79.9207C961.912 79.8593 961.837 80.0466 961.848 80.1479C961.749 80.8385 961.775 82.3562 962.668 82.9023C963.101 83.1673 963.662 83.108 964.194 82.9215M963.551 80.2123C964.417 80.5285 965.337 81.1219 965.602 82.1329C965.29 82.3822 964.758 82.7235 964.194 82.9215M963.551 80.2123C964.814 80.0611 967.607 80.3398 968.683 82.6648C967.979 83.3782 966.095 84.4282 964.194 82.9215",
    stroke: "black",
    strokeWidth: 0.5
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 74.2105C984.095 75.1385 985.521 76.8954 987.248 76.4995C988.273 76.2647 988.715 76.1634 988.868 76.1284C988.868 76.1284 988.868 76.1284 988.868 76.1284C988.941 76.1116 988.973 76.1044 988.868 76.1284C989.022 75.1461 988.64 73.0269 985.885 72.4082C983.129 71.7895 983.213 73.352 983.599 74.2105Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 73.5846C980.406 74.2772 982.36 75.4174 983.836 74.4368C984.712 73.8552 985.09 73.6042 985.221 73.5175C985.221 73.5175 985.221 73.5175 985.221 73.5175C985.283 73.476 985.31 73.4581 985.221 73.5175C985.017 72.5443 983.912 70.6964 981.116 71.0909C978.319 71.4854 978.949 72.9177 979.614 73.5846Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 73.6451C976.08 74.1948 978.198 74.9644 979.438 73.6451C980.173 72.8626 980.49 72.5249 980.6 72.4083C980.6 72.4083 980.6 72.4083 980.6 72.4083C980.652 72.3524 980.675 72.3283 980.6 72.4083C980.212 71.4463 978.779 69.7697 976.145 70.7592C973.51 71.7486 974.401 73.0954 975.176 73.6451Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 74.155C973.014 74.5115 975.146 74.8809 976.141 73.5066C976.731 72.6914 976.986 72.3396 977.074 72.2181C977.074 72.2181 977.074 72.2181 977.074 72.2181C977.116 72.1599 977.134 72.1348 977.074 72.2181C976.566 71.4124 974.957 70.1236 972.584 71.4138C970.21 72.7039 971.254 73.7788 972.072 74.155Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 74.0367C968.639 74.5864 970.757 75.356 971.996 74.0367C972.732 73.2542 973.049 72.9165 973.158 72.7999C973.158 72.7999 973.158 72.7999 973.158 72.7999C973.211 72.744 973.234 72.7199 973.158 72.7999C972.771 71.8379 971.338 70.1613 968.703 71.1508C966.069 72.1402 966.96 73.487 967.735 74.0367Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 72.8468C960.648 73.4638 960.612 75.1653 960.714 75.9389C960.701 76.0525 960.78 76.2621 961.201 76.1911C961.549 76.1545 962.032 76.0513 962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171C962.668 72.6109 962.069 72.5474 961.605 72.8468Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 75.8576C962.032 76.0513 961.549 76.1545 961.201 76.1911C960.78 76.2621 960.701 76.0525 960.714 75.9389C960.612 75.1653 960.648 73.4638 961.605 72.8468C962.069 72.5474 962.668 72.6109 963.235 72.8171M962.533 75.8576C963.46 75.4985 964.446 74.8283 964.735 73.6935C964.403 73.4158 963.837 73.036 963.235 72.8171M962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171",
    stroke: "black",
    strokeWidth: 0.5
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 72.2523C984.095 73.1802 985.521 74.9371 987.248 74.5413C988.273 74.3065 988.715 74.2051 988.868 74.1701C988.868 74.1701 988.868 74.1701 988.868 74.1702C988.941 74.1534 988.973 74.1461 988.868 74.1701C989.022 73.1879 988.64 71.0687 985.885 70.45C983.129 69.8313 983.213 71.3937 983.599 72.2523Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 71.6263C980.406 72.319 982.36 73.4591 983.836 72.4786C984.712 71.897 985.09 71.6459 985.221 71.5593C985.221 71.5593 985.221 71.5593 985.221 71.5593C985.283 71.5177 985.31 71.4998 985.221 71.5593C985.017 70.586 983.912 68.7382 981.116 69.1327C978.319 69.5272 978.949 70.9595 979.614 71.6263Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 71.6868C976.08 72.2365 978.198 73.0061 979.438 71.6868C980.173 70.9043 980.49 70.5666 980.6 70.45C980.6 70.45 980.6 70.45 980.6 70.45C980.652 70.3941 980.675 70.37 980.6 70.45C980.212 69.488 978.779 67.8115 976.145 68.8009C973.51 69.7904 974.401 71.1371 975.176 71.6868Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 72.1967C973.014 72.5532 975.146 72.9227 976.141 71.5483C976.731 70.7331 976.986 70.3813 977.074 70.2598C977.074 70.2599 977.074 70.2599 977.074 70.2599C977.116 70.2016 977.134 70.1765 977.074 70.2598C976.566 69.4542 974.957 68.1654 972.584 69.4555C970.21 70.7457 971.254 71.8205 972.072 72.1967Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 72.0784C968.639 72.6281 970.757 73.3977 971.996 72.0784C972.732 71.2959 973.049 70.9582 973.158 70.8416C973.158 70.8416 973.158 70.8416 973.158 70.8416C973.211 70.7857 973.234 70.7616 973.158 70.8416C972.771 69.8796 971.338 68.2031 968.703 69.1925C966.069 70.182 966.96 71.5287 967.735 72.0784Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 70.8885C960.648 71.5056 960.612 73.207 960.714 73.9807C960.701 74.0943 960.78 74.3038 961.201 74.2329C961.549 74.1962 962.032 74.0931 962.533 73.8993C963.881 74.0621 967.932 73.5006 969.094 70.8885C968.346 70.0926 965.274 69.1596 963.235 70.8589C962.668 70.6526 962.069 70.5892 961.605 70.8885Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 73.8993C962.032 74.0931 961.549 74.1962 961.201 74.2329C960.78 74.3038 960.701 74.0943 960.714 73.9807C960.612 73.207 960.648 71.5056 961.605 70.8885C962.069 70.5892 962.668 70.6526 963.235 70.8589M962.533 73.8993C963.46 73.5402 964.446 72.87 964.735 71.7352C964.403 71.4575 963.837 71.0778 963.235 70.8589M962.533 73.8993C963.881 74.0621 967.932 73.5006 969.094 70.8885C968.346 70.0926 965.274 69.1596 963.235 70.8589",
    stroke: "black",
    strokeWidth: 0.5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M610.045 55.5631C615.337 51.6245 631.268 41.3416 633.475 35.7508C634.062 36.9495 630.433 46.7668 622.737 49.9443C626.966 51.0487 636.286 53.4162 639.73 54.0514C644.035 54.8454 651.595 55.3918 654.022 52.2416C656.449 49.0913 659.794 43.3791 653.953 37.3604C656.046 37.3507 659.987 39.7741 659.009 49.5445C660.524 50.2739 664.809 49.8772 666.878 41.6025C668.362 35.6663 667.762 31.5999 664.478 25.3369C659.986 16.7705 666.094 22.7717 666.799 24.3961C667.504 26.0205 672.422 33.6711 671.058 40.4206C670.719 42.0989 670.458 43.2063 670.259 43.9076C672.73 41.8602 677.211 37.8145 679.17 34.8026C678.22 38.7211 674.74 47.263 668.428 50.0824L664.61 53.9367C661.601 56.9733 651.614 59.5771 643.593 59.7304C635.572 59.8836 630.928 56.6978 626.158 56.1385C621.389 55.5792 615.331 57.4192 612.553 60.2223C609.776 63.0254 611.441 55.5566 610.045 55.5631Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M659.003 36.7676C656.429 43.2901 645.818 51.7099 640.834 55.1044C642.698 55.8399 646.069 55.6616 647.521 55.4805C657.986 45.5733 659.536 38.8772 659.003 36.7676Z",
    fill: "#FFFBFB"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M593.955 54.0371C588.663 50.0985 572.732 39.8156 570.525 34.2248C569.938 35.4235 573.567 45.2408 581.263 48.4183C577.034 49.5227 567.714 51.8902 564.27 52.5254C559.965 53.3194 552.405 53.8658 549.978 50.7156C547.551 47.5653 544.206 41.8531 550.047 35.8344C547.954 35.8247 544.013 38.2481 544.991 48.0185C543.476 48.7479 539.191 48.3512 537.122 40.0765C535.638 34.1403 536.238 30.0739 539.522 23.8109C544.014 15.2445 537.906 21.2457 537.201 22.8701C536.496 24.4945 531.578 32.1451 532.942 38.8946C533.281 40.5729 533.542 41.6803 533.741 42.3816C531.27 40.3342 526.789 36.2885 524.83 33.2766C525.78 37.1951 529.26 45.737 535.572 48.5564L539.39 52.4107C542.399 55.4473 552.386 58.0511 560.407 58.2044C568.428 58.3576 573.072 55.1718 577.842 54.6125C582.611 54.0532 588.669 55.8932 591.447 58.6963C594.224 61.4994 592.559 54.0306 593.955 54.0371Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M544.591 36.0001C547.165 42.5226 557.776 50.9424 562.759 54.337C560.896 55.0725 557.525 54.8941 556.073 54.7131C545.608 44.8058 544.058 38.1098 544.591 36.0001Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M599.057 57.3718C598.136 58.2925 596.81 55.2344 596.262 53.5902C589.883 55.1028 588.014 58.6049 587.877 60.1669C588.425 60.1669 589.702 60.2491 590.425 60.5779C591.149 60.9067 591.275 63.9485 591.247 65.4282C591.165 65.0994 590.179 64.935 589.521 64.935C588.863 64.935 586.89 67.2368 586.644 70.5251C586.397 73.8135 587.877 77.1018 588.617 77.7595C589.209 78.2856 590.069 77.9787 590.425 77.7595C590.82 78.2856 592.179 87.9534 592.809 92.7215C593.138 93.971 595.851 95.0507 597.166 95.4343C596.673 98.1472 598.399 102.258 599.057 104.806C599.715 107.355 601.688 107.519 602.181 107.519C602.674 107.519 602.756 104.724 602.921 104.806C603.085 104.888 602.181 105.71 604.401 107.272C606.176 108.522 608.593 99.901 609.58 95.4343C611.092 94.8424 612.512 93.1599 613.033 92.3926C612.769 90.6827 614.512 81.4863 615.417 77.1018C615.663 77.2937 616.272 77.628 616.732 77.4307C617.307 77.184 618.047 73.3202 618.047 70.5251C618.047 67.7301 615.006 64.935 614.512 64.6061C614.019 64.2773 614.595 60.4957 615.828 60.1669C616.814 59.9038 617.006 60.0573 616.979 60.1669C618.129 58.0294 609.58 52.7681 609.909 53.5902C610.172 54.2479 608.155 55.8372 607.114 56.5497C604.812 58.0294 604.154 56.0564 602.839 55.0699C601.523 54.0834 600.208 56.2209 599.057 57.3718Z",
    fill: "white",
    stroke: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M598.579 96.8136C598.71 99.3785 600.826 102.65 601.867 103.966C602.853 105.357 601.867 97.7179 602.525 96.8136C603.182 95.9093 602.853 97.8001 603.1 98.2934C603.347 98.7866 603.347 97.5535 603.758 96.8136C604.169 96.0737 603.347 103.966 604.169 103.966C604.991 103.966 607.128 97.8001 607.457 95.2516C607.786 92.7032 606.388 91.5523 605.813 90.3191C605.237 89.086 605.237 91.7989 604.169 92.2099C603.1 92.621 604.004 91.3878 604.169 90.3191C604.333 89.2504 602.689 90.2369 601.867 89.6615C601.045 89.086 601.867 91.3878 600.88 92.2099C599.894 93.032 600.14 91.059 599.894 89.6615C599.647 88.2639 598.414 93.6075 598.579 96.8136Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.18908
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M591.893 71.4716C591.893 74.0646 591.347 76.6138 590.049 75.8685C588.917 75.8685 588 73.7665 588 71.1735C588.615 68.3416 589.054 67.0001 590.186 67.0001C591.142 67.7454 592.371 68.4161 591.893 71.4716Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M616.76 69.9944C616.539 72.3528 617.571 73.0899 615.507 75.1536C613.444 75.8169 612.964 73.348 612.633 70.8051C612.302 68.2621 612.117 66.8988 613.941 65.9313C614.844 65.2036 616.097 68.3729 616.76 69.9944Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M598.646 73.5668C598.4 74.4163 598.054 76.4277 598.646 77.6772C599.386 79.2392 600.044 80.1435 600.044 80.719C600.044 81.2944 599.715 87.7889 600.373 87.1312C601.03 86.4735 601.606 84.5828 601.935 85.1582C602.263 85.7337 602.674 86.4735 602.757 85.8159C602.839 85.1582 603.085 81.7055 602.757 80.719C602.428 79.7324 602.263 78.4993 602.757 76.8551C603.25 75.211 603.661 72.6625 603.003 71.5938C602.346 70.5251 603.743 67.6478 603.496 67.1545C603.359 67.6752 603.168 69.0782 603.496 70.5251C603.908 72.3337 604.154 74.3067 603.825 75.0466C603.496 75.7864 602.757 77.9239 603.003 78.9926C603.25 80.0613 603.496 83.8429 603.496 84.5005C603.496 85.1582 603.332 85.5693 603.825 85.1582C604.319 84.7472 604.483 84.3361 604.647 84.7472C604.812 85.1582 605.058 86.0625 605.141 86.3091C605.223 86.5558 605.881 86.4735 605.963 85.487C606.045 84.5005 605.881 82.4453 606.292 80.9656C606.703 79.4858 607.114 78.1705 607.525 78.5815",
    stroke: "black",
    strokeWidth: 0.567239,
    strokeLinecap: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M609.168 52.0817C609.431 51.6213 610.593 52.2735 611.141 52.6572C612.21 53.397 614.676 55.1234 615.991 56.1099C618.112 57.7005 617.636 59.1516 617.718 60.0559C617.8 60.9602 616.649 61.5357 616.649 60.5492C616.649 59.5627 610.155 54.4658 609.168 53.7259C608.182 52.986 608.839 52.6572 609.168 52.0817Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M595.028 51.9173C596.146 51.3912 596.426 52.5202 596.426 53.1504C596.497 53.7259 595.521 54.2191 594.042 55.1234C592.562 56.0277 591.329 57.9185 590.342 58.5762C589.356 59.2339 588.698 60.5492 587.629 60.5492C586.561 60.5492 588.863 57.3431 589.356 56.6032C589.849 55.8633 593.631 52.575 595.028 51.9173Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M609.168 52.0817C609.431 51.6213 610.593 52.2735 611.141 52.6572C612.21 53.397 614.676 55.1234 615.991 56.1099C618.112 57.7005 617.636 59.1516 617.718 60.0559C617.8 60.9602 616.649 61.5357 616.649 60.5492C616.649 59.5627 610.155 54.4658 609.168 53.7259C608.182 52.986 608.839 52.6572 609.168 52.0817Z",
    stroke: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M595.028 51.9173C596.146 51.3912 596.426 52.5202 596.426 53.1504C596.497 53.7259 595.521 54.2191 594.042 55.1234C592.562 56.0277 591.329 57.9185 590.342 58.5762C589.356 59.2339 588.698 60.5492 587.629 60.5492C586.561 60.5492 588.863 57.3431 589.356 56.6032C589.849 55.8633 593.631 52.575 595.028 51.9173Z",
    stroke: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 615,
    cy: 59.5001,
    rx: 1,
    ry: 1.5,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590,
    cy: 60.5001,
    rx: 1,
    ry: 1.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3713_17473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 727,
    y: 30,
    width: 146,
    height: 153
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 30.0001,
    width: 146,
    height: 152,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3713_17473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.09 117.152C809.624 115.442 808.443 101.68 808.036 95.0131C797.704 101.68 777.377 115.686 778.721 118.373C780.4 121.732 777.499 140.207 778.721 144.177C779.942 148.146 812.922 119.29 811.09 117.152Z",
    fill: "#FFFBFB",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.311 43.2347C787.677 42.6239 768.147 47.7524 765.582 54.5925C762.376 63.1427 763.903 76.4261 763.445 78.1056C762.987 79.7851 760.696 83.6022 762.071 86.1978C763.445 88.7934 764.972 98.565 766.498 99.9392C768.025 101.313 773.369 110.627 773.827 112.764C774.285 114.902 777.95 119.483 779.324 120.093C780.698 120.704 789.706 123.605 794.134 117.345C798.562 111.085 801.615 112.459 806.348 102.687C808.545 98.1531 809.066 95.6255 808.909 94.3123C809.813 94.8808 811.155 94.7218 812.761 92.1524C815.357 87.5719 817.952 87.5719 818.105 82.8388C818.258 78.1056 816.273 75.9681 815.051 75.6627C813.83 75.3573 807.875 79.1744 807.875 81.4646C806.857 73.5251 805.127 57.2187 806.348 55.5086C810.208 50.1054 800.93 43.3688 795.311 43.2347Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.602 76.2535C781.48 75.3985 782.569 73.4543 783.129 72.5891C784.656 71.0623 788.778 71.8257 790 71.5204C791.221 71.215 796.107 74.4213 797.329 75.9481C798.55 77.475 798.55 78.8491 797.481 81.9028C796.412 84.9564 790 84.0403 788.778 83.8876C787.557 83.7349 785.877 80.2233 784.961 79.6125C784.045 79.0018 781.755 77.3223 781.602 76.2535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.869 75.0321C776.991 72.7113 775.393 72.4365 774.579 72.5891C771.373 71.673 766.639 73.3526 766.181 73.5052C765.723 73.6579 766.334 77.3223 764.96 78.8491C763.586 80.3759 765.113 83.1242 767.403 84.3457C769.693 85.5671 774.579 82.5135 775.648 81.9028C776.716 81.292 776.716 77.933 776.869 75.0321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.958 74.2483C777.347 77.8618 776.065 85.5468 775.82 87.379C775.515 89.6692 774.294 92.8755 776.126 93.3336C777.958 93.7916 779.179 93.4863 779.637 92.8755C780.095 92.2648 781.47 91.5014 782.386 91.8068C783.302 92.1121 784.676 93.4863 784.676 94.097C784.676 94.7077 786.05 95.0131 786.355 94.555",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.523 93.9142C782.813 91.1049 781.317 91.5015 779.943 92.5702C779.943 93.7917 780.859 93.1508 782.691 93.9142C784.157 94.525 784.523 94.1687 784.523 93.9142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.35901,
    transform: "matrix(-1 0 0 1 789.714 76.9966)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.05365,
    transform: "matrix(-1 0 0 1 772.003 77.6074)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 771.545 77.4548)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1492)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1492)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 787.73 78.0654)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 771.24 78.3707)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.606 76.2331C782.741 75.6733 780.492 74.6147 778.415 74.859C776.339 75.1033 775.514 75.8769 775.362 76.2331",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.844 95.4865C781.256 94.9979 779.637 95.6901 779.027 96.0973C778.06 95.5883 775.759 94.8758 774.294 96.0973C772.461 97.6241 771.545 101.441 768.95 102.51C766.873 103.365 763.911 102.866 762.69 102.51C768.644 106.632 772.003 104.953 774.294 104.953C776.584 104.953 776.278 101.441 777.347 101.441C778.202 101.441 778.823 101.848 779.027 102.052C779.739 101.696 781.5 101.288 782.844 102.51C784.523 104.037 791.547 104.8 795.669 104.953C798.967 105.075 800.809 102.357 801.318 100.983C800.402 102.052 798.265 101.441 795.669 101.441C793.074 101.441 784.829 96.0973 782.844 95.4865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.277 44.425C791.75 45.1884 791.903 47.4786 789.918 49.1581C789.177 49.9215 772.207 50.5323 766.71 54.96C761.214 59.3878 764.115 79.2365 763.046 78.4731C761.977 77.7097 763.198 62.1361 764.115 56.6396C765.031 51.143 770.069 45.9518 770.527 44.425C770.985 42.8982 782.589 40.1499 788.238 39.2338C792.758 38.5009 796.941 41.8803 798.468 43.6616C797.247 43.6616 794.498 43.8142 793.277 44.425Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.013 44.425C797.622 44.1426 793.277 44.425 793.277 49.1581C798.315 52.5171 798.315 54.6547 799.69 54.96C801.064 55.2654 803.303 55.0103 804.372 55.9264C805.441 56.8425 802.54 63.7132 804.372 64.6293C806.204 65.5454 804.474 66.0034 805.746 71.6527C806.088 73.1717 807.35 82.7135 808.189 80.8136C808.952 79.0839 814.602 73.3322 817.044 77.4546C817.334 77.9436 820.302 67.6327 818.011 66.1059C815.721 64.579 814.602 54.7049 813.227 53.0254C811.853 51.3459 810.784 45.2386 801.013 44.425Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.212 120.134C814.55 116.775 812.922 109.873 811.7 109.14C810.173 108.224 805.898 115.4 803.761 116.011C801.623 116.622 798.875 118.912 798.111 120.134C797.348 121.355 791.393 125.936 787.576 125.63C785.056 125.429 787.563 132.633 789.946 138.16C787.982 134.025 785.048 128.562 782.691 126.394C778.874 122.882 778.263 121.202 777.805 122.118C777.347 123.035 776.431 127.462 777.805 130.821C779.179 134.18 786.508 148.991 790.325 148.838C793.378 148.716 808.189 129.651 815.212 120.134Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.365 114.484C852.143 124.867 901.831 187.35 888.063 183.686L861.655 183.686L755.943 198.379C743.396 200.728 735.915 207.94 735.6 198.379C735.231 187.193 749.52 163.897 755.943 155.721C758.647 152.28 772.308 137.234 772.919 133.57C773.408 130.638 776.584 126.546 778.11 124.867C777.5 127.157 784.218 141.204 793.531 137.234C802.845 133.264 813.141 113.857 815.365 114.484Z",
    fill: "black"
  }))), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.5 213.204C1015.5 234.731 1010.41 254.049 1002.36 267.866C994.255 281.769 983.577 289.5 972.5 289.5C961.423 289.5 950.745 281.769 942.644 267.866C934.592 254.049 929.5 234.731 929.5 213.204C929.5 191.676 934.592 172.358 942.644 158.541C950.745 144.638 961.423 136.907 972.5 136.907C983.577 136.907 994.255 144.638 1002.36 158.541C1010.41 172.358 1015.5 191.676 1015.5 213.204Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3713_17473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 934,
    y: 140,
    width: 77,
    height: 144
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 972.5,
    cy: 212.056,
    rx: 38.463,
    ry: 71.7593,
    fill: "#D38337",
    fillOpacity: 0.3
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3713_17473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 913.701,
    y: 205.683,
    width: 116.611,
    height: 7.53704,
    transform: "rotate(-24.2173 913.701 205.683)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.937,
    y: 221.312,
    width: 116.611,
    height: 2.36387,
    transform: "rotate(-24.2173 915.937 221.312)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.381,
    y: 259.201,
    width: 116.611,
    height: 17.452,
    transform: "rotate(-24.2173 919.381 259.201)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.31 224.268C1007.95 223.414 1008.76 221.438 1008.62 219.175C1009.56 219.941 1010.41 220.98 1011.05 222.233C1011.45 223.003 1011.73 223.792 1011.91 224.567L1016.04 240.791C1016.35 241.992 1014.83 242.779 1014.04 241.832L1003.4 229.148C1002.83 228.529 1002.33 227.803 1001.91 226.985C1001.26 225.733 1000.92 224.433 1000.84 223.217C1002.59 224.642 1004.66 225.121 1006.31 224.268Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.65 211.566C1029.65 211.566 1028.06 211.747 1027.33 212.128C1026.59 212.51 1022.81 213.239 1023.85 218.048C1022.86 218.048 1022.1 218.022 1021.16 218.51C1019 219.632 1017.75 220.643 1018.27 225.57C1016.97 224.151 1015.94 224.685 1015.28 225.031C1013.36 226.026 1012.54 228.651 1012.55 230.686C1012.32 230.362 1012.11 230.019 1011.93 229.659C1009.2 224.337 1012.65 217.08 1019.64 213.451C1022.99 211.708 1026.55 211.119 1029.65 211.566Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M982.526 236.048C982.526 236.048 983.593 234.849 984.327 234.467C985.061 234.086 987.845 231.401 991.131 235.048C991.704 234.236 992.127 233.592 993.067 233.104C995.226 231.982 996.77 231.541 1000.46 234.825C1000.06 232.937 1001.09 232.403 1001.75 232.057C1003.67 231.062 1006.27 231.904 1007.91 233.097C1007.78 232.721 1007.63 232.351 1007.44 231.991C1004.71 226.668 996.838 225.296 989.852 228.925C986.497 230.668 983.957 233.248 982.526 236.048Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M994.305 239.268C995.948 238.414 996.759 236.438 996.621 234.175C997.563 234.941 998.412 235.98 999.054 237.233C999.449 238.003 999.733 238.792 999.911 239.567L1004.04 255.791C1004.35 256.992 1002.83 257.779 1002.04 256.832L991.396 244.148C990.832 243.529 990.325 242.803 989.906 241.985C989.264 240.733 988.915 239.433 988.841 238.217C990.593 239.642 992.663 240.121 994.305 239.268Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.65 226.566C1017.65 226.566 1016.06 226.747 1015.33 227.128C1014.59 227.51 1010.81 228.239 1011.85 233.048C1010.86 233.048 1010.1 233.022 1009.16 233.51C1007 234.632 1005.75 235.643 1006.27 240.57C1004.97 239.151 1003.94 239.685 1003.28 240.031C1001.36 241.026 1000.54 243.651 1000.55 245.686C1000.32 245.362 1000.11 245.019 999.929 244.659C997.201 239.337 1000.65 232.08 1007.64 228.451C1010.99 226.708 1014.55 226.119 1017.65 226.566Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M970.526 251.048C970.526 251.048 971.593 249.849 972.327 249.467C973.061 249.086 975.845 246.401 979.131 250.048C979.704 249.236 980.127 248.592 981.067 248.104C983.226 246.982 984.77 246.541 988.455 249.825C988.06 247.937 989.087 247.403 989.754 247.057C991.669 246.062 994.273 246.904 995.91 248.097C995.782 247.721 995.625 247.351 995.44 246.991C992.713 241.668 984.838 240.296 977.852 243.925C974.497 245.668 971.957 248.248 970.526 251.048Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.389C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.908C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.389C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.908C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M964 178.501C964.618 178.442 965.254 178.464 965.895 178.576C968.677 179.061 970.8 181.108 971.531 183.667C972.477 183.368 973.506 183.286 974.55 183.468C976.95 183.886 978.807 185.593 979.54 187.76C980.231 187.603 980.963 187.578 981.703 187.707C983.831 188.078 985.462 189.625 986.054 191.57C986.178 191.191 986.275 190.802 986.343 190.403C987.361 184.509 981.893 178.634 974.132 177.28C970.404 176.63 966.826 177.141 964 178.501Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M991.911 189.417C992.129 189.044 992.302 188.633 992.419 188.191C993.079 185.715 991.758 183.207 989.468 182.591C987.178 181.974 984.787 183.481 984.127 185.957C984.009 186.399 983.954 186.841 983.957 187.274L983.882 187.254L984.018 189.53C984.229 193.066 988.795 194.296 990.736 191.34L991.986 189.437L991.911 189.417Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M986.943 183.968C987.405 183.332 987.614 182.483 987.452 181.611C987.291 180.739 986.792 180.023 986.134 179.596C985.673 180.233 985.464 181.081 985.626 181.953C985.787 182.825 986.285 183.541 986.943 183.968Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M990.44 184.91C990.357 184.127 990.598 183.287 991.171 182.613C991.745 181.939 992.532 181.57 993.315 181.53C993.398 182.314 993.157 183.153 992.583 183.827C992.01 184.501 991.222 184.871 990.44 184.91Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.038 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.389C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.908C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.161 970.438 194.822 977.832 197.551C981.384 198.861 984.229 201.103 986 203.701Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.038 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.389C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.908C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.161 970.438 194.822 977.832 197.551C981.384 198.861 984.229 201.103 986 203.701Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M937 190.501C937.618 190.442 938.254 190.464 938.895 190.576C941.677 191.061 943.8 193.108 944.531 195.667C945.477 195.368 946.506 195.286 947.55 195.468C949.95 195.886 951.807 197.593 952.54 199.76C953.231 199.603 953.963 199.578 954.703 199.707C956.831 200.078 958.462 201.625 959.054 203.57C959.178 203.191 959.275 202.802 959.343 202.403C960.361 196.509 954.893 190.634 947.132 189.28C943.404 188.63 939.826 189.141 937 190.501Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M964.911 201.417C965.129 201.044 965.302 200.633 965.419 200.191C966.079 197.715 964.758 195.207 962.468 194.591C960.178 193.974 957.787 195.481 957.127 197.957C957.009 198.399 956.954 198.841 956.957 199.274L956.882 199.254L957.018 201.53C957.229 205.066 961.795 206.296 963.736 203.34L964.986 201.437L964.911 201.417Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M959.943 195.968C960.405 195.332 960.614 194.483 960.452 193.611C960.291 192.739 959.792 192.023 959.134 191.596C958.673 192.233 958.464 193.081 958.626 193.953C958.787 194.825 959.285 195.541 959.943 195.968Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M963.44 196.91C963.357 196.127 963.598 195.287 964.171 194.613C964.745 193.939 965.532 193.57 966.315 193.53C966.398 194.314 966.157 195.153 965.583 195.827C965.01 196.501 964.222 196.871 963.44 196.91Z",
    fill: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 538,
    width: 136,
    height: 1.99999,
    transform: "rotate(90 425 538)",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M489.039 655.886C488.335 666.459 497.263 671.158 501.815 672.186H537.498C544.194 672.186 548.218 666.606 549.392 663.815C556.441 651.833 537.498 641.348 537.498 641.348C546.309 654.564 538.379 657.648 536.176 658.97C533.974 660.291 535.295 653.243 533.093 650.159C531.33 647.692 523.841 643.992 526.044 638.705C519.877 644.432 524.282 650.6 522.079 655.886C519.877 661.172 519.877 657.648 518.115 655.445C516.51 653.44 521.198 649.278 518.115 637.384C514.7 624.212 517.233 618 517.233 618C517.233 618 504.458 627.251 503.577 640.027C502.872 650.247 500.64 654.858 499.612 655.886C503.841 648.133 498.731 638.852 496.088 637.384C495.207 649.718 489.744 645.313 489.039 655.886Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M495.674 661.054C495.203 668.275 501.169 671.484 504.211 672.186H528.058C532.533 672.186 535.222 668.375 536.007 666.47C540.718 658.286 530.009 651.921 530.009 651.921C534.414 661.613 528.647 662.258 527.175 663.16C525.703 664.063 525.314 659.754 523.842 657.648C522.664 655.963 520.758 651.921 523.401 646.194C515.471 648.419 519.972 657.39 518.5 661C517.028 664.61 517.678 663.004 516.5 661.5C515.428 660.13 519.901 653.066 515.104 646.194C510.185 639.146 511.066 633.859 511.066 633.859C511.066 633.859 505.389 633.859 505.389 650.224C505.389 657.219 503.426 660.352 502.739 661.054C505.566 655.759 500.938 646.316 499.172 645.313C501.374 656.327 496.145 653.834 495.674 661.054Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-489-inside-4_3713_17473",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.474 661.978C515.424 660.421 517.584 660.006 519.297 661.051C519.392 661.109 519.484 661.171 519.572 661.235L519.579 661.223L529.168 667.076L529.161 667.087C530.663 668.182 531.165 670.146 530.267 671.617C529.369 673.088 527.393 673.54 525.733 672.705L525.726 672.716L525.46 672.554C525.454 672.551 525.449 672.547 525.444 672.544C525.438 672.541 525.433 672.537 525.428 672.534L516.137 666.864L516.144 666.853C516.046 666.804 515.95 666.75 515.855 666.692C514.141 665.646 513.523 663.536 514.474 661.978Z"
  }))), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.474 661.978C515.424 660.421 517.584 660.006 519.297 661.051C519.392 661.109 519.484 661.171 519.572 661.235L519.579 661.223L529.168 667.076L529.161 667.087C530.663 668.182 531.165 670.146 530.267 671.617C529.369 673.088 527.393 673.54 525.733 672.705L525.726 672.716L525.46 672.554C525.454 672.551 525.449 672.547 525.444 672.544C525.438 672.541 525.433 672.537 525.428 672.534L516.137 666.864L516.144 666.853C516.046 666.804 515.95 666.75 515.855 666.692C514.141 665.646 513.523 663.536 514.474 661.978Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M519.572 661.235L519.278 661.639L519.716 661.959L519.999 661.496L519.572 661.235ZM519.579 661.223L519.84 660.797L519.413 660.536L519.152 660.963L519.579 661.223ZM529.168 667.076L529.595 667.336L529.855 666.909L529.429 666.649L529.168 667.076ZM529.161 667.087L528.734 666.827L528.494 667.22L528.867 667.491L529.161 667.087ZM525.733 672.705L525.957 672.258L525.546 672.051L525.306 672.444L525.733 672.705ZM525.726 672.716L525.465 673.143L525.892 673.403L526.152 672.977L525.726 672.716ZM525.46 672.554L525.72 672.127L525.718 672.126L525.46 672.554ZM525.428 672.534L525.69 672.109L525.688 672.107L525.428 672.534ZM516.137 666.864L515.71 666.604L515.45 667.03L515.876 667.291L516.137 666.864ZM516.144 666.853L516.571 667.113L516.853 666.65L516.369 666.406L516.144 666.853ZM519.558 660.625C517.648 659.459 515.164 659.887 514.047 661.718L514.9 662.239C515.684 660.954 517.52 660.553 519.037 661.478L519.558 660.625ZM519.867 660.831C519.767 660.759 519.664 660.69 519.558 660.625L519.037 661.478C519.12 661.529 519.2 661.583 519.278 661.639L519.867 660.831ZM519.999 661.496L520.006 661.484L519.152 660.963L519.145 660.975L519.999 661.496ZM519.319 661.65L528.908 667.502L529.429 666.649L519.84 660.797L519.319 661.65ZM528.741 666.815L528.734 666.827L529.588 667.348L529.595 667.336L528.741 666.815ZM530.694 671.878C531.749 670.149 531.133 667.906 529.455 666.683L528.867 667.491C530.193 668.458 530.581 670.142 529.84 671.357L530.694 671.878ZM525.508 673.151C527.362 674.084 529.639 673.606 530.694 671.878L529.84 671.357C529.099 672.571 527.423 672.996 525.957 672.258L525.508 673.151ZM525.306 672.444L525.299 672.456L526.152 672.977L526.159 672.965L525.306 672.444ZM525.986 672.289L525.72 672.127L525.199 672.981L525.465 673.143L525.986 672.289ZM525.183 672.971C525.189 672.974 525.195 672.978 525.201 672.982L525.718 672.126C525.714 672.123 525.709 672.12 525.704 672.117L525.183 672.971ZM525.165 672.96C525.171 672.963 525.177 672.967 525.183 672.971L525.704 672.117C525.699 672.114 525.695 672.111 525.69 672.109L525.165 672.96ZM525.688 672.107L516.397 666.437L515.876 667.291L525.167 672.961L525.688 672.107ZM516.564 667.124L516.571 667.113L515.717 666.592L515.71 666.604L516.564 667.124ZM515.594 667.119C515.701 667.184 515.809 667.244 515.919 667.299L516.369 666.406C516.283 666.363 516.199 666.316 516.115 666.265L515.594 667.119ZM514.047 661.718C512.93 663.549 513.684 665.953 515.594 667.119L516.115 666.265C514.598 665.339 514.117 663.523 514.9 662.239L514.047 661.718Z",
    fill: "black",
    mask: "url(#path-489-inside-4_3713_17473)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M514.499 661.994C515.382 660.547 517.221 660.077 518.601 660.92C519.981 661.762 520.404 663.612 519.521 665.059C518.639 666.506 516.799 666.976 515.419 666.133C514.039 665.291 513.616 663.441 514.499 661.994Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-492-inside-5_3713_17473",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.485 669.322C526.485 671.147 524.858 672.626 522.85 672.626C522.739 672.626 522.629 672.622 522.52 672.613V672.626H511.634C511.628 672.626 511.623 672.626 511.617 672.626C511.611 672.626 511.605 672.626 511.6 672.626H511.286V672.613C509.434 672.461 507.982 671.046 507.982 669.322C507.982 667.599 509.434 666.183 511.286 666.032V666.018H522.52V666.032C522.629 666.023 522.739 666.018 522.85 666.018C524.858 666.018 526.485 667.497 526.485 669.322Z"
  }))), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.485 669.322C526.485 671.147 524.858 672.626 522.85 672.626C522.739 672.626 522.629 672.622 522.52 672.613V672.626H511.634C511.628 672.626 511.623 672.626 511.617 672.626C511.611 672.626 511.605 672.626 511.6 672.626H511.286V672.613C509.434 672.461 507.982 671.046 507.982 669.322C507.982 667.599 509.434 666.183 511.286 666.032V666.018H522.52V666.032C522.629 666.023 522.739 666.018 522.85 666.018C524.858 666.018 526.485 667.497 526.485 669.322Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M522.52 672.613L522.561 672.114L522.02 672.07V672.613H522.52ZM522.52 672.626V673.126H523.02V672.626H522.52ZM511.634 672.626V672.126L511.632 672.126L511.634 672.626ZM511.6 672.626L511.602 672.126H511.6V672.626ZM511.286 672.626H510.786V673.126H511.286V672.626ZM511.286 672.613H511.786V672.152L511.327 672.114L511.286 672.613ZM511.286 666.032L511.327 666.53L511.786 666.492V666.032H511.286ZM511.286 666.018V665.518H510.786V666.018H511.286ZM522.52 666.018H523.02V665.518H522.52V666.018ZM522.52 666.032H522.02V666.574L522.561 666.53L522.52 666.032ZM522.85 673.126C525.088 673.126 526.985 671.467 526.985 669.322H525.985C525.985 670.827 524.627 672.126 522.85 672.126V673.126ZM522.479 673.111C522.602 673.121 522.725 673.126 522.85 673.126V672.126C522.753 672.126 522.656 672.122 522.561 672.114L522.479 673.111ZM522.02 672.613V672.626H523.02V672.613H522.02ZM522.52 672.126H511.634V673.126H522.52V672.126ZM511.617 673.126C511.623 673.126 511.63 673.126 511.636 673.126L511.632 672.126C511.627 672.126 511.622 672.126 511.617 672.126V673.126ZM511.597 673.126C511.604 673.126 511.61 673.126 511.617 673.126V672.126C511.612 672.126 511.607 672.126 511.602 672.126L511.597 673.126ZM511.6 672.126H511.286V673.126H511.6V672.126ZM511.786 672.626V672.613H510.786V672.626H511.786ZM507.482 669.322C507.482 671.347 509.176 672.942 511.246 673.111L511.327 672.114C509.692 671.98 508.482 670.745 508.482 669.322H507.482ZM511.246 665.533C509.176 665.703 507.482 667.298 507.482 669.322H508.482C508.482 667.9 509.692 666.664 511.327 666.53L511.246 665.533ZM511.786 666.032V666.018H510.786V666.032H511.786ZM511.286 666.518H522.52V665.518H511.286V666.518ZM522.02 666.018V666.032H523.02V666.018H522.02ZM522.85 665.518C522.725 665.518 522.602 665.523 522.479 665.533L522.561 666.53C522.656 666.522 522.753 666.518 522.85 666.518V665.518ZM526.985 669.322C526.985 667.178 525.088 665.518 522.85 665.518V666.518C524.627 666.518 525.985 667.817 525.985 669.322H526.985Z",
    fill: "black",
    mask: "url(#path-492-inside-5_3713_17473)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M526.455 669.322C526.455 670.987 524.963 672.376 523.071 672.376C521.179 672.376 519.687 670.987 519.687 669.322C519.687 667.657 521.179 666.268 523.071 666.268C524.963 666.268 526.455 667.657 526.455 669.322Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M751.998 665.542C752.021 665.266 751.817 665.025 751.542 665.002C751.266 664.979 751.025 665.183 751.002 665.459L751.998 665.542ZM751.002 665.459L750.502 671.459L751.498 671.542L751.998 665.542L751.002 665.459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3713_17473",
    x: 406.678,
    y: 66.2581,
    width: 16.9107,
    height: 14.2342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.50318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.751592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3713_17473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3713_17473",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3713_17473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Haunted-contrast.b3e9f95292a9cab91bf37a47a955db29.svg";